function formatINR(num) {
  var x = Math.round(num).toString();
  var lastThree = x.slice(-3);
  var rest = x.slice(0, -3);
  if (rest) lastThree = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
  return lastThree;
}

document.addEventListener("DOMContentLoaded", async function () {
  // ======================================================================
  // SECTION 1: Logging and Initialization
  // ======================================================================
    localStorage.removeItem('pcBuilderState');
    setupValidationClearListeners();


     const skipGPUBtn = document.getElementById('skip-gpu-btn');
    const unskipGPUBtn = document.getElementById('unskip-gpu-btn');
    
    if (skipGPUBtn) {
        skipGPUBtn.addEventListener('click', function() {
            window.PCBuilderState.skipGPU();
        });
    }
    
    if (unskipGPUBtn) {
        unskipGPUBtn.addEventListener('click', function() {
            window.PCBuilderState.unskipGPU();
        });
    }


  // SINGLE PRODUCT VARIANT ID - Only one product in cart
  
  const MAX_CUSTOM_MODS = 5;

  // 🔥 GLOBAL ENUMS STORAGE - Fetched from API
  window.PCBuilderEnums = {};

  // Initialize PCBuilderState
  if (!window.PCBuilderState) {
    window.PCBuilderState = {};
  }

  // Initialize all component states with new structure - INCLUDING CUSTOM MOD
  window.PCBuilderState = {
    cabinet: { brand: null, model: null },
    processor: { brand: null, generation: null, model: null },
    motherboard: { brand: null, model: null },
    gpu: { brand: null, model: null },
    gpuSkipped: false,
     smpsNeedsGPUCheck: false,
    'primary-storage': { type: null, brand: null, model: null },
    'secondary-storage': { type: null, brand: null, model: null },
    'optional-storage': { type: null, brand: null, model: null },
    ram: { brand: null, model: null },
    cooler: { type: null, brand: null, model: null },
    smps: { brand: null, model: null },
    os: { brand: null, model: null },
    customMods: [{ category: null, brand: null, model: null }],
    storageChoices: {
      'secondary-storage': false,
      'optional-storage': false
    }
  };

  // ======================================================================
  // SECTION 2: Enhanced LocalStorage Management
  // ======================================================================
 window.PCBuilderState.saveToLocalStorage = function() {
    
    try {
        // Previous cabinet model check karo
        const previousState = localStorage.getItem('pcBuilderState');
        let shouldUpdateImages = false;
        
        if (previousState) {
            const parsed = JSON.parse(previousState);
            // Check if cabinet model has changed
            if (parsed.cabinet?.model?.id !== this.cabinet?.model?.id) {
                shouldUpdateImages = true;
            }
        } else if (this.cabinet?.model?.id) {
            // First time cabinet selected
            shouldUpdateImages = true;
        }

        const stateToSave = {
            cabinet: this.cabinet,
            processor: this.processor,
            motherboard: this.motherboard,
            gpu: this.gpu,
            gpuSkipped: this.gpuSkipped,
            smpsNeedsGPUCheck: this.smpsNeedsGPUCheck,
            'primary-storage': this['primary-storage'],
            'secondary-storage': this['secondary-storage'],
            'optional-storage': this['optional-storage'],
            ram: this.ram,
            cooler: this.cooler,
            smps: this.smps,
            os: this.os,
            customMods: this.customMods,
            storageChoices: this.storageChoices,
            lastUpdated: new Date().toISOString()
        };
        
        localStorage.setItem('pcBuilderState', JSON.stringify(stateToSave));
        
        // Cabinet model change par images check karo
        if (shouldUpdateImages) {
            this.updateCabinetImages();
        }
        
    } catch (error) {
        console.error('❌ Error saving to localStorage:', error);
    }
};



// Helper: ensure Shopify CDN URL + add ?v=timestamp
function buildShopifyImageUrl(src) {
  // If full URL already present, use as-is
  const isAbsolute = /^https?:\/\//i.test(src);
  const base = isAbsolute
    ? src
    : `https://cdn.shopify.com/s/files/1/0655/8698/7217/files/${src}`; // src can be "image_url" or "folder/image.png"

  try {
    const url = new URL(base);
    // Append/overwrite v param with current timestamp
    url.searchParams.set('v', Date.now().toString());
    return url.toString();
  } catch {
    // If base is a bare path, fallback safely
    const glue = base.includes('?') ? '&' : '?';
    return `${base}${glue}v=${Date.now()}`;
  }
}

window.PCBuilderState.updateCabinetImages = function () {
  const mainImage = document.getElementById('main-pc-image');
  const thumbnailContainer = document.querySelector('.flex.justify-center.lg\\:justify-start.gap-2');

  if (!mainImage || !thumbnailContainer) {
    console.warn('Image elements not found');
    return;
  }

  const hasCabinetImages =
    this.cabinet?.model?.images &&
    Array.isArray(this.cabinet.model.images) &&
    this.cabinet.model.images.length > 0;
    

  if (hasCabinetImages) {
    // Normalize and timestamp all cabinet image URLs
    const rawImages = this.cabinet.model.images; // could be ["image_url", "..."] or absolute URLs
    const cabinetImages = rawImages.map((img) => buildShopifyImageUrl(img));


    // Update main image (1000x1000 assumed from API; timestamped URL used)
    mainImage.src = cabinetImages[0];

    // Clear existing thumbnails
    thumbnailContainer.innerHTML = '';

    // Create up to 4 thumbnails
    cabinetImages.slice(0, 4).forEach((imageUrl, index) => {
      const thumbnailDiv = document.createElement('div');

      thumbnailDiv.className = `cursor-pointer transition-all duration-200 hover:scale-105 flex-shrink-0 ${
        index === 0 ? 'opacity-100' : 'opacity-70'
      }`;

      // On click, switch main image to the selected cabinet image
      thumbnailDiv.onclick = () => this.changeToCabinetImage(imageUrl, thumbnailDiv);

      thumbnailDiv.innerHTML = `
        <img src="${imageUrl}"
             alt="Cabinet View ${index + 1}"
             class="w-16 h-16 sm:w-18 sm:h-18 lg:w-20 lg:h-20 rounded-lg bg-[#eaeaea] object-contain p-1 sm:p-2 border-2 transition-all duration-200 ${
               index === 0
                 ? 'border-[#800be5] shadow-[0_0_0_2px_rgba(128,11,229,0.3)]'
                 : 'border-transparent hover:border-[#800be5]'
             }">
      `;

      thumbnailContainer.appendChild(thumbnailDiv);
    });

  } else {
  }
};


// Thumbnail click handler - main image ko 1000x1000 mein change karo
window.PCBuilderState.changeToCabinetImage = function(imageUrl, clickedElement) {
    const mainImage = document.getElementById('main-pc-image');
    if (mainImage) {
        // Main image ko 1000x1000 resolution mein set karo
        mainImage.src = imageUrl; // Assuming API se high-res images aa rahi hain
    }
    
    // Thumbnail selection logic - exact same CSS classes
    const allThumbnails = document.querySelectorAll('.cursor-pointer.transition-all.duration-200');
    allThumbnails.forEach(thumb => {
        thumb.classList.remove('opacity-100');
        thumb.classList.add('opacity-70');
        const img = thumb.querySelector('img');
        if (img) {
            img.classList.remove('border-[#800be5]', 'shadow-[0_0_0_2px_rgba(128,11,229,0.3)]');
            img.classList.add('border-transparent');
        }
    });
    
    // Selected thumbnail highlight
    if (clickedElement) {
        clickedElement.classList.remove('opacity-70');
        clickedElement.classList.add('opacity-100');
        const img = clickedElement.querySelector('img');
        if (img) {
            img.classList.remove('border-transparent');
            img.classList.add('border-[#800be5]', 'shadow-[0_0_0_2px_rgba(128,11,229,0.3)]');
        }
    }
};


// Thumbnail click handler for cabinet images
window.PCBuilderState.changeToCabinetImage = function(imageUrl, clickedElement) {
    const mainImage = document.getElementById('main-pc-image');
    if (mainImage) {
        // CSS same rahegi, sirf src change hoga
        mainImage.src = imageUrl;
    }
    
    // Thumbnail selection logic - exact same CSS classes
    const allThumbnails = document.querySelectorAll('.cursor-pointer.transition-all.duration-200');
    allThumbnails.forEach(thumb => {
        thumb.classList.remove('opacity-100');
        thumb.classList.add('opacity-70');
        const img = thumb.querySelector('img');
        if (img) {
            img.classList.remove('border-[#800be5]', 'shadow-[0_0_0_2px_rgba(128,11,229,0.3)]');
            img.classList.add('border-transparent');
        }
    });
    
    // Selected thumbnail highlight - exact same CSS
    if (clickedElement) {
        clickedElement.classList.remove('opacity-70');
        clickedElement.classList.add('opacity-100');
        const img = clickedElement.querySelector('img');
        if (img) {
            img.classList.remove('border-transparent');
            img.classList.add('border-[#800be5]', 'shadow-[0_0_0_2px_rgba(128,11,229,0.3)]');
        }
    }
};



window.PCBuilderState.skipGPU = function() {
    this.gpuSkipped = true;
    this.smpsNeedsGPUCheck = false;
    
    // Clear GPU selections
    this.gpu = { brand: null, model: null };
    
    // Update GPU UI to show skip message
    this.updateGPUSkipUI();
    
    // **CRITICAL: Reset and reload SMPS for cabinet-only dependency**
    this.clearSMPSDropdowns();
    this.smps = { brand: null, model: null };
    
    // Enable SMPS with cabinet-only dependency
    setTimeout(async () => {
        if (this.cabinet?.model?.id) {
            await this.reloadSMPSWithoutGPU();
        }
    }, 200);
    
    // Show sections after GPU skip
    this.showSectionsAfterGPUSkip();
    
    // Save state immediately after skipping
    this.saveToLocalStorage();
    
    // Update pricing and build review immediately
    this.updateFinalPrice();
    this.updateBuildReview();
    this.checkFinalAddToCartStatus();
    
};



window.PCBuilderState.unskipGPU = async function() {
    
    // **CHECK IF SMPS IS ALREADY SELECTED - SHOW CONFIRMATION**
    if (this.smps?.model) {
        
        try {
            const message = 'GPU Change may need SMPS Upgrade. Do you want to continue?';
            const userConfirmed = await customConfirm(message, 'Confirm GPU Change');
            
            if (!userConfirmed) {
                return; // Exit without changing anything
            }
            
        } catch (error) {
            console.error('Error in confirmation modal:', error);
            return; // Exit on error
        }
    }
    
    // **PROCEED WITH UNSKIP AFTER CONFIRMATION**
    this.gpuSkipped = false;
    this.smpsNeedsGPUCheck = true;
    
    // Update GPU UI only
    this.updateGPUSkipUI();
    
    // **CRITICAL: Reset SMPS completely for cabinet+GPU dependency**
    this.clearSMPSDropdowns();
    this.smps = { brand: null, model: null };
    
    // Save state
    this.saveToLocalStorage();
    
    // Update pricing and build review immediately
    this.updateFinalPrice();
    this.updateBuildReview();
    this.checkFinalAddToCartStatus();
    
    // Reload GPU options first
    setTimeout(() => loadComponentBrands('gpu'), 100);
    
};


window.PCBuilderState.resetSMPSUI = function() {
    
    // Reset Brand Dropdown (smps1)
    const brandInput = document.querySelector('#smps1 .custom-dropdown-input');
    const brandOptions = document.querySelector('#smps1 .custom-dropdown-options');
    const brandDisplay = document.querySelector('#smps1 .selected-display');
    
    if (brandInput) {
        brandInput.value = '';
        brandInput.disabled = true; // **START DISABLED**
        brandInput.placeholder = 'Select components first';
        brandInput.classList.remove('loading');
        brandInput.style.display = '';
    }
    
    if (brandOptions) {
        brandOptions.innerHTML = '';
        brandOptions.style.display = 'none';
        brandOptions.classList.remove('opening');
    }
    
    if (brandDisplay) {
        brandDisplay.remove();
    }
    
    // Reset Model Dropdown (smps2)  
    const modelInput = document.querySelector('#smps2 .custom-dropdown-input');
    const modelOptions = document.querySelector('#smps2 .custom-dropdown-options');
    const modelDisplay = document.querySelector('#smps2 .selected-display');
    
    if (modelInput) {
        modelInput.value = '';
        modelInput.disabled = true; // **START DISABLED**
        modelInput.placeholder = 'Select brand first';
        modelInput.classList.remove('loading');
        modelInput.style.display = '';
    }
    
    if (modelOptions) {
        modelOptions.innerHTML = '';
        modelOptions.style.display = 'none';
        modelOptions.classList.remove('opening');
    }
    
    if (modelDisplay) {
        modelDisplay.remove();
    }
    
};


window.PCBuilderState.reloadSMPSWithoutGPU = async function() {
    const brandInput = document.querySelector('#smps1 .custom-dropdown-input');
    const brandOptionsList = document.querySelector('#smps1 .custom-dropdown-options');
    
    if (!brandInput || !brandOptionsList) return;
    
    const cabinetId = this.cabinet?.model?.id;
    
    if (!cabinetId) {
        brandInput.disabled = true;
        brandInput.placeholder = 'Select Cabinet first';
        return;
    }
    
    
    // **ENABLE INPUT PROPERLY**
    brandInput.disabled = false;
    brandInput.placeholder = 'Loading brands...';
    brandInput.classList.add('loading');
    
    // Clear existing selections
    this.smps = { brand: null, model: null };
    
    try {
        // **CORRECT API URL for cabinet-only SMPS loading**
        const apiUrl = `${apiEndpoints.smps.brands}cabinetid=${cabinetId}`;
        
        const res = await fetch(apiUrl, {
            headers: {
                'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        
        const json = await res.json();
        const brandOptions = json.data?.data || json.data;
        
        brandInput.classList.remove('loading');
        
        if (!brandOptions || brandOptions.length === 0) {
            brandInput.placeholder = 'No brands available';
            brandInput.disabled = true;
            return;
        }
        
        
        populateOptions(brandInput, brandOptionsList, brandOptions, async (brand) => {
            // **ENABLE MODEL INPUT**
            const modelInput = document.querySelector('#smps2 .custom-dropdown-input');
            const modelOptions = document.querySelector('#smps2 .custom-dropdown-options');
            const modelDisplay = document.querySelector('#smps2 .selected-display');
            
            if (modelInput) {
                modelInput.value = '';
                modelInput.disabled = false;
                modelInput.placeholder = 'Loading models...';
                modelInput.classList.remove('loading');
                modelInput.style.display = '';
            }
            
            if (modelOptions) {
                modelOptions.innerHTML = '';
                modelOptions.style.display = 'none';
            }
            
            if (modelDisplay) {
                modelDisplay.remove();
            }
            
            this.smps.brand = brand;
            this.smps.model = null;
            this.saveToLocalStorage();
            
            await this.loadSMPSModelsWithoutGPU(brand);
            
        }, false);
        
        brandInput.placeholder = 'Brand';
        
        // **SHOW SMPS SECTION**
        const smpsSection = document.getElementById('smps-section');
        if (smpsSection) {
            smpsSection.style.display = 'block';
        }
        
        // **REMOVE DEPENDENCY DISABLED CLASS**
        const firstDropdown = document.querySelector('#smps1');
        if (firstDropdown) {
            firstDropdown.classList.remove('dependency-disabled');
        }
        
    } catch (error) {
        console.error('Error reloading SMPS brands without GPU:', error);
        brandInput.classList.remove('loading');
        brandInput.placeholder = 'Error loading brands';
        brandInput.disabled = true;
    }
};







window.PCBuilderState.clearSMPSDropdowns = function() {
    ['smps1', 'smps2'].forEach(id => {
        const input = document.querySelector(`#${id} .custom-dropdown-input`);
        const options = document.querySelector(`#${id} .custom-dropdown-options`);
        const display = document.querySelector(`#${id} .selected-display`);
        
        if (input) {
            input.value = '';
            input.disabled = true;
            input.placeholder = 'Select dependencies first';
            input.style.display = '';
        }
        
        if (options) {
            options.innerHTML = '';
            options.style.display = 'none';
        }
        
        if (display) {
            display.remove();
        }
    });
};


// **Updated showSectionsAfterGPUSkip function**
window.PCBuilderState.showSectionsAfterGPUSkip = function() {
    const sectionsToShow = [
        'primary-storage-section',
        'secondary-storage-section', 
        'optional-storage-section',
        'ram-section'
        // Don't auto-show SMPS since it depends on cabinet only when GPU skipped
    ];
    
    sectionsToShow.forEach(sectionId => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.style.display = 'block';
        }
    });
    
    // Load primary storage options
    setTimeout(() => {
        loadTypeOptions('primary-storage');
        setupStorageChoiceRadios();
    }, 100);
    
};


// **NEW FUNCTION - Show sections after GPU skip**
window.PCBuilderState.showSectionsAfterGPUSkip = function() {
    const sectionsToShow = [
        'primary-storage-section',
        'secondary-storage-section', 
        'optional-storage-section',
        'ram-section'
        // Don't auto-show SMPS since it depends on cabinet only when GPU skipped
    ];
    
    sectionsToShow.forEach(sectionId => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.style.display = 'block';
        }
    });
    
    // Load primary storage options
    setTimeout(() => {
        loadTypeOptions('primary-storage');
        setupStorageChoiceRadios();
    }, 100);
    
    
};





window.PCBuilderState.updateGPUSkipUI = function() {
    const gpuSelectionContainer = document.getElementById('gpu-selection-container');
    const skipBtn = document.getElementById('skip-gpu-btn');
    const unSkipBtn = document.getElementById('unskip-gpu-btn');
    
    if (this.gpuSkipped) {
        // GPU is skipped - show "Select Graphics Card" button, hide "Skip" button
        gpuSelectionContainer.classList.add('hidden');
        skipBtn.style.display = 'none';
        unSkipBtn.style.display = 'block';
        
        // Clear GPU dropdowns
        this.clearGPUDropdowns();
    } else {
        // GPU is not skipped - show "Skip" button, hide "Select Graphics Card" button
        gpuSelectionContainer.classList.remove('hidden');
        skipBtn.style.display = 'block';
        unSkipBtn.style.display = 'none';
    }
};


window.PCBuilderState.clearGPUDropdowns = function() {
    ['gpu1', 'gpu2'].forEach(id => {
        const input = document.querySelector(`#${id} .custom-dropdown-input`);
        const options = document.querySelector(`#${id} .custom-dropdown-options`);
        const display = document.querySelector(`#${id} .selected-display`);
        
        if (input) {
            input.value = '';
            input.disabled = true;
            input.placeholder = 'Select component first';
        }
        if (options) {
            options.innerHTML = '';
            options.style.display = 'none';
        }
        if (display) {
            display.remove();
            input.style.display = '';
        }
    });
};

window.PCBuilderState.proceedWithoutGPU = function() {
    // Enable SMPS without GPU dependency
    setTimeout(async () => {
        if (window.PCBuilderState.checkSMPSDependenciesWithoutGPU()) {
            await loadSMPSBrandsWithoutGPU();
        }
    }, 200);
};

// Add new function to check SMPS dependencies without GPU
window.PCBuilderState.checkSMPSDependenciesWithoutGPU = function() {
    const cabinetId = this.cabinet?.model?.id;
    return cabinetId != null;
};


// Universal radio button fix
function setupStorageChoiceRadios() {
    
    // Initialize default values
    window.PCBuilderState.storageChoices = {
        'secondary-storage': false,
        'optional-storage': false,
        'cooler': true,
        'custom-mod': false
    };
    
    // Setup all radio button groups
    const radioGroups = [
        'secondary-storage-choice',
        'optional-storage-choice', 
        'cooler-choice',
        'custom-mod-choice'
    ];
    
    
    radioGroups.forEach(groupName => {
        const radios = document.querySelectorAll(`input[name="${groupName}"]`);
        const storageType = groupName.replace('-choice', '');
        const fields = document.getElementById(`${storageType}-fields`);
        
        radios.forEach(radio => {
            radio.addEventListener('change', (e) => {
                const isYes = e.target.value === 'yes';
                window.PCBuilderState.storageChoices[storageType] = isYes;
                
                if (isYes) {
                    if (fields) {
                        fields.classList.remove('storage-fields-hidden');
                        fields.classList.add('storage-fields-visible');
                    }
                    
                    // Enable specific functionality
                    if (storageType === 'custom-mod') {
                        enableFirstCustomMod();
                        setupAddMoreButton();
                        loadCustomModCategories(0);
                    } else if (storageType !== 'cooler') {
                        enableStorageDropdowns(storageType);
                        loadTypeOptions(storageType);
                    }
                } else {
                    if (fields) {
                        fields.classList.add('storage-fields-hidden');
                        fields.classList.remove('storage-fields-visible');
                    }
                    
                    if (storageType !== 'custom-mod' && storageType !== 'cooler') {
                        resetAndDisableStorage(storageType);
                    }
                }
                
                // CRITICAL: Always update these after radio selection
                window.PCBuilderState.updateFinalPrice();
                window.PCBuilderState.updateBuildReview();
                window.PCBuilderState.checkFinalAddToCartStatus();
                window.PCBuilderState.saveToLocalStorage();
                
            });
        });
    });
    
}


// New SMPS loading function without GPU requirement
async function loadSMPSBrandsWithoutGPU() {
    const brandInput = document.querySelector('#smps1 .custom-dropdown-input');
    const brandOptionsList = document.querySelector('#smps1 .custom-dropdown-options');
    
    if (!brandInput || !brandOptionsList) return;
    
    const cabinetId = window.PCBuilderState.cabinet?.model?.id;
    
    if (!cabinetId) {
        brandInput.disabled = true;
        brandInput.placeholder = 'Select Cabinet first';
        return;
    }
    
    brandInput.disabled = false;
    brandInput.placeholder = 'Loading brands...';
    brandInput.classList.add('loading');
    
    try {
        // API call with only cabinet ID (no GPU requirement)
        const apiUrl = `${apiEndpoints.smps.brands}?cabinetid=${cabinetId}`;
        const res = await fetch(apiUrl, {
            headers: {
                'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        
        const json = await res.json();
        const brandOptions = json.data?.data || json.data;
        
        brandInput.classList.remove('loading');
        
        if (brandOptions.length === 0) {
            brandInput.placeholder = 'No brands available';
            return;
        }
        
        populateOptions(brandInput, brandOptionsList, brandOptions, async (brand) => {
            // Reset model dropdown
            const modelInput = document.querySelector('#smps2 .custom-dropdown-input');
            const modelOptions = document.querySelector('#smps2 .custom-dropdown-options');
            
            if (modelInput) {
                modelInput.value = '';
                modelInput.disabled = false;
                modelInput.placeholder = 'Loading models...';
                const display = modelInput.parentNode.querySelector('.selected-display');
                if (display) {
                    display.remove();
                    modelInput.style.display = '';
                }
            }
            if (modelOptions) {
                modelOptions.innerHTML = '';
            }
            
            window.PCBuilderState.smps.brand = brand;
            window.PCBuilderState.smps.model = null;
            window.PCBuilderState.saveToLocalStorage();
            
            await loadSMPSModelsWithoutGPU(brand);
        }, false);
        
        brandInput.placeholder = 'Brand';
    } catch (error) {
        console.error('Error loading SMPS brands without GPU:', error);
        brandInput.classList.remove('loading');
    }
}

// Add this function around line 3000 - Custom Mod Reset Helper
function resetCustomModData() {
    
    // Clear state data completely
    window.PCBuilderState.customMods = [];
    
    // Clear all custom mod UI inputs
    const allCustomModGroups = document.querySelectorAll('.custom-mod-group');
    allCustomModGroups.forEach((group, index) => {
        // Reset all dropdown inputs in this group
        const inputs = group.querySelectorAll('.custom-dropdown-input');
        inputs.forEach(input => {
            input.value = "";
            input.disabled = true;
            input.placeholder = "Select category first";
            
            // Remove any selected display
            const display = input.parentNode.querySelector('.selected-display');
            if (display) display.remove();
            
            // Show input, hide dropdown
            input.style.display = '';
            const options = input.parentNode.querySelector('.custom-dropdown-options');
            if (options) {
                options.innerHTML = '';
                options.style.display = 'none';
            }
        });
        
        // Remove additional mod sections (keep only first one)
        if (index > 0) {
            group.remove();
        }
    });
    
    // Reset add more button
    updateAddButtonVisibility();
    
}


// Line 315 के आसपास - यह function add करें या fix करें
window.PCBuilderState.loadSMPSModelsWithoutGPU = async function(brand) {
    const modelInput = document.querySelector('#smps2 .custom-dropdown-input');
    const modelOptionsList = document.querySelector('#smps2 .custom-dropdown-options');
    
    if (!modelInput || !modelOptionsList) return;
    
    modelInput.classList.add('loading');
    
    try {
        const brandId = brand.id;
        const cabinetId = this.cabinet?.model?.id;
        
        // **API call with only cabinet ID (no GPU ID)**
        const apiUrl = `${apiEndpoints.smps.models}${brandId}&cabinet_id=${cabinetId}`;
        
        const res = await fetch(apiUrl, {
            headers: {
                'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        
        const json = await res.json();
        let models = json.data?.data || json.data;
        
        models = models.map(model => {
            model.displayPrice = this.validatePrice(model.price || model.sellingprice || 0);
            return model;
        });
        
        modelInput.classList.remove('loading');
        
        if (models.length === 0) {
            modelInput.placeholder = 'No models available';
            return;
        }
        
        populateOptions(modelInput, modelOptionsList, models, async (model) => {
            this.smps.model = model;
            this.saveToLocalStorage();
            this.updateFinalPrice();
            this.checkFinalAddToCartStatus();
            this.updateBuildReview();
        }, true);
        
        modelInput.placeholder = 'Model';
        modelInput.disabled = false;
        
    } catch (error) {
        console.error('Error loading SMPS models without GPU:', error);
        modelInput.classList.remove('loading');
        modelInput.placeholder = 'Error loading models';
    }
};


 window.PCBuilderState.loadFromLocalStorage = function() {
    try {
        const savedState = localStorage.getItem('pcBuilderState');
        if (savedState) {
            const parsedState = JSON.parse(savedState);
            Object.keys(parsedState).forEach(key => {
                if (this.hasOwnProperty(key) || key === 'gpuSkipped') {
                    this[key] = parsedState[key];
                }
            });
            return true;
        }
    } catch (error) {
        console.error('Error loading from localStorage:', error);
        return false;
    }
};

  // ======================================================================
  // SECTION 3: Dependency Definitions
  // ======================================================================
  const dependencies = {
    motherboard: ['processor.generation', 'cabinet.model'],
    ram: ['motherboard.model', 'processor.generation'],
    cooler: ['processor.generation', 'cabinet.model'],
    smps: ['cabinet.model', 'gpu.model']
  };

  // ======================================================================
  // SECTION 4: API Endpoints
  // ======================================================================
  const apiEndpoints = {
    'enums': 'https://bitkart.co.in/api/enums',
    'cabinet': {
      brands: 'https://bitkart.co.in/api/cabinet/brands',
      models: 'https://bitkart.co.in/api/cabinet/models?brand_id='
    },
    'processor': {
      brands: 'https://bitkart.co.in/api/processor/brands',
      generations: 'https://bitkart.co.in/api/processor/generations?brand_id=',
      models: 'https://bitkart.co.in/api/processor/models?brand_id='
    },
    'motherboard': {
      brands: 'https://bitkart.co.in/api/motherboard/brands?',
      models: 'https://bitkart.co.in/api/motherboard/models?brand_id='
    },
    'gpu': {
      brands: 'https://bitkart.co.in/api/graphicCard/brands?',
      models: 'https://bitkart.co.in/api/graphicCard/models?brand_id='
    },
    'primary-storage': {
      brands: 'https://bitkart.co.in/api/storage/brands?storage_type=',
      models: 'https://bitkart.co.in/api/storage/models?brand_id='
    },
    'secondary-storage': {
      brands: 'https://bitkart.co.in/api/storage/brands?storage_type=',
      models: 'https://bitkart.co.in/api/storage/models?brand_id='
    },
    'optional-storage': {
      brands: 'https://bitkart.co.in/api/storage/brands?storage_type=',
      models: 'https://bitkart.co.in/api/storage/models?brand_id='
    },
    'ram': {
      brands: 'https://bitkart.co.in/api/ram/brands?',
      models: 'https://bitkart.co.in/api/ram/models?brand_id='
    },
    'cooler': {
      brands: 'https://bitkart.co.in/api/cooler/brands?',
      models: 'https://bitkart.co.in/api/cooler/models?brand_id='
    },
    'smps': {
      brands: 'https://bitkart.co.in/api/smps/brands?',
      models: 'https://bitkart.co.in/api/smps/models?brand_id='
    },
    'os': {
      list: 'https://bitkart.co.in/api/os'
    },
    'custom-mod': { 
      categories: 'https://bitkart.co.in/api/custom-mod/categories',
      brands: 'https://bitkart.co.in/api/custom-mod/brands?category_id=',
      models: 'https://bitkart.co.in/api/custom-mod/models?'
    }
  };

  // ======================================================================
  // SECTION 5: ✅ FIXED Enhanced Dependency Management
  // ======================================================================
  
  
// SECTION 5 FIXED Enhanced Dependency Management WITH MODAL CONFIRMATION
const resetMap = {
  'cabinet': {
    reset: ['cooler', 'smps'],
    preserve: ['gpu', 'processor', 'primary-storage', 'secondary-storage', 'optional-storage', 'os']
  },
  'gpu': {
    reset: ['smps'],
    preserve: ['cabinet', 'processor', 'motherboard', 'ram', 'cooler', 'primary-storage', 'secondary-storage', 'optional-storage', 'os']
  },
  'processor': {
    reset: ['motherboard', 'ram', 'cooler'],
    preserve: ['cabinet', 'gpu', 'smps', 'primary-storage', 'secondary-storage', 'optional-storage', 'os']
  },
  'motherboard': {
    reset: ['ram'],
    preserve: ['cabinet', 'processor', 'gpu', 'smps', 'cooler', 'primary-storage', 'secondary-storage', 'optional-storage', 'os']
  }
};

// Enhanced Smart Reset with proper value preservation
window.PCBuilderState.smartResetDependentComponents = async function(changedComponent) {
    
    const resetConfig = resetMap[changedComponent];
    if (!resetConfig) return true;
    
    // BACKUP current values before showing modal
    const originalValues = {};
    originalValues[changedComponent] = JSON.parse(JSON.stringify(this[changedComponent]));
    
    // Check if any components will be reset that have selections
    const componentsToReset = [];
    resetConfig.reset.forEach(component => {
        if (this.hasValidSelection(component)) {
            componentsToReset.push(component);
        }
    });
    
    // If no components to reset, proceed without modal
    if (componentsToReset.length === 0) {
        await this.proceedWithReset(changedComponent, resetConfig);
        return true;
    }
    
    // Show confirmation modal
    const componentDisplayName = changedComponent.charAt(0).toUpperCase() + changedComponent.slice(1);
    const dependentNames = componentsToReset.map(comp => 
        comp.charAt(0).toUpperCase() + comp.slice(1).replace('-', ' ')
    ).join(', ');
    
    let message;
    if (changedComponent === 'cabinet') {
        message = 'Cabinet change may reset motherboard, cooler & SMPS. Do you want to continue?';
    } else if (changedComponent === 'gpu') {
        message = 'GPU Change may need SMPS Upgrade. Do you want to continue?';
    } else if (changedComponent === 'processor') {
        message = 'Processor change may reset motherboard, RAM & cooler. Do you want to continue?';
    } else if (changedComponent === 'motherboard') {
        message = 'Motherboard change may require new RAM selection. Do you want to continue?';
    } else {
        message = `Changing ${componentDisplayName} will reset the following selected components: ${dependentNames}. Do you want to continue?`;
    }
    
    try {
        const userConfirmed = await customConfirm(message, `Confirm ${componentDisplayName} Change`);
        
        if (userConfirmed) {
            await this.proceedWithReset(changedComponent, resetConfig);
            return true;
        } else {
            
            // 🔥 RESTORE original values
            this[changedComponent] = originalValues[changedComponent];
            
            // 🔥 RESTORE UI display
            this.restoreComponentUI(changedComponent, originalValues[changedComponent]);
            
            // Save restored state
            this.saveToLocalStorage();
            
            return false;
        }
    } catch (error) {
        console.error('❌ Error in confirmation modal:', error);
        
        // 🔥 ERROR case mein bhi restore karein
        this[changedComponent] = originalValues[changedComponent];
        this.restoreComponentUI(changedComponent, originalValues[changedComponent]);
        this.saveToLocalStorage();
        
        return false;
    }
};

// NEW FUNCTION: UI restore helper
window.PCBuilderState.restoreComponentUI = function(component, originalData) {
    
    const prefix = getComponentPrefix(component);
    const dropdownCount = getDropdownCount(component);
    
    // Restore dropdowns based on component type
    if (component === 'processor' && originalData.brand) {
        // Restore brand
        const brandInput = document.querySelector(`#${prefix}1 .custom-dropdown-input`);
        if (brandInput && originalData.brand) {
            updateInputDisplay(brandInput, originalData.brand, false);
        }
        
        // Restore generation
        const generationInput = document.querySelector(`#${prefix}2 .custom-dropdown-input`);
        if (generationInput && originalData.generation) {
            updateInputDisplay(generationInput, originalData.generation, false);
        }
        
        // Restore model
        const modelInput = document.querySelector(`#${prefix}3 .custom-dropdown-input`);
        if (modelInput && originalData.model) {
            updateInputDisplay(modelInput, originalData.model, true);
        }
    } else if ((component.includes('storage') || component === 'cooler') && (originalData.type || originalData.brand)) {
        // Restore storage components (type, brand, model)
        const typeInput = document.querySelector(`#${prefix}1 .custom-dropdown-input`);
        if (typeInput && originalData.type) {
            updateInputDisplay(typeInput, originalData.type, false);
        }
        
        const brandInput = document.querySelector(`#${prefix}2 .custom-dropdown-input`);
        if (brandInput && originalData.brand) {
            updateInputDisplay(brandInput, originalData.brand, false);
        }
        
        const modelInput = document.querySelector(`#${prefix}3 .custom-dropdown-input`);
        if (modelInput && originalData.model) {
            updateInputDisplay(modelInput, originalData.model, true);
        }
    } else {
        // Regular components (cabinet, gpu, motherboard, etc.)
        const brandInput = document.querySelector(`#${prefix}1 .custom-dropdown-input`);
        if (brandInput && originalData.brand) {
            updateInputDisplay(brandInput, originalData.brand, false);
        }
        
        const modelInput = document.querySelector(`#${prefix}2 .custom-dropdown-input`);
        if (modelInput && originalData.model) {
            updateInputDisplay(modelInput, originalData.model, true);
        }
    }
    
};


// Helper function to check if component has valid selection
window.PCBuilderState.hasValidSelection = function(component) {
    const componentData = this[component];
    if (!componentData) return false;
    
    if (component === 'os') {
        return componentData.model !== null;
    }

    if (component.includes('storage') || component === 'cooler') {
        return componentData.type !== null && componentData.model !== null;
    }
    
    if (component === 'processor') {
        return componentData.brand !== null && componentData.generation !== null && componentData.model !== null;
    }
    
    return componentData.brand !== null && componentData.model !== null;
};

// Proceed with reset after confirmation
window.PCBuilderState.proceedWithReset = async function(changedComponent, resetConfig) {
    
    // Preserve important values
    const preservedGPU = this.gpu ? {...this.gpu} : null;
    const preservedProcessor = this.processor ? {...this.processor} : null;
    
    // Save current state to localStorage first
    this.saveToLocalStorage();
    
    // Reset specified components
    resetConfig.reset.forEach(component => {
        this.resetComponentUI(component);
        this.setComponentDependencyState(component);
    });
    
    // CRITICAL: Cabinet change GPU restore
    if (changedComponent === 'cabinet' && preservedGPU) {
        this.gpu = preservedGPU;
    }
    
    // CRITICAL: Processor generation/model change brand preserve
    if (changedComponent === 'processor' && preservedProcessor?.brand) {
        this.processor.brand = preservedProcessor.brand;
    }
    
    // Save updated state
    this.saveToLocalStorage();
    
    // Update UI
    this.updateFinalPrice();
    this.updateBuildReview();
    this.checkFinalAddToCartStatus();
    
    // Re-enable components that can now be loaded
    setTimeout(() => {
        this.reloadDependentComponents(changedComponent);
    }, 200);
};

// Continue with existing code below...

  // ✅ केवल UI reset करें, important state preserve करें
  window.PCBuilderState.resetComponentUI = function(component) {
    const prefix = getComponentPrefix(component);
    
    // State में केवल selections clear करें, structure maintain करें
    if (component === 'processor') {
      this[component] = { 
        brand: this[component]?.brand || null, // Brand preserve करें अगर है
        generation: null, 
        model: null 
      };
    } else if (component === 'os') {
      this[component] = { brand: null, model: null };
    } else if (component.includes('storage') || component === 'cooler') {
      this[component] = { 
        type:  null, // Type preserve करें अगर है
        brand: null, 
        model: null 
      };
    } else {
      this[component] = { brand: null, model: null };
    }
    
    // UI reset करें
    const dropdownCount = getDropdownCount(component);
    for (let i = 1; i <= dropdownCount; i++) {
      const input = document.querySelector(`#${prefix}${i} .custom-dropdown-input`);
      const options = document.querySelector(`#${prefix}${i} .custom-dropdown-options`);
      
      if (input) {
          if (component === 'cooler') {
        input.value = '';
        input.disabled = true;
        input.placeholder = getPlaceholder(component, i);
        
        const display = input.parentNode.querySelector('.selected-display');
        if (display) {
          display.remove();
          input.style.display = '';
        }
      }
        // First dropdown को preserve करें अगर type/brand है
        if (i === 1 && (component.includes('storage') || component === 'cooler' || component === 'processor')) {
          // Keep first dropdown as is if it has value
          if (!input.value) {
            input.disabled = true;
            input.placeholder = getPlaceholder(component, i);
          }
        } else {
          input.value = '';
          input.disabled = true;
          input.placeholder = getPlaceholder(component, i);
          
          // Remove fake displays
          const display = input.parentNode.querySelector('.selected-display');
          if (display) {
            display.remove();
            input.style.display = '';
          }
        }
      }
      
      if (options && i > 1) {
        options.innerHTML = '';
        options.style.display = 'none';
      }
    }
    
  };

  // ✅ FIXED: Enhanced Reload Dependent Components
  window.PCBuilderState.reloadDependentComponents = function(changedComponent) {
    const reloadMap = {
      'cabinet': async () => {
        // Cabinet change के बाद motherboard reload करें
        if (this.checkDependencies('motherboard')) {
          await loadComponentBrands('motherboard');
        }
        
        // ✅ ENHANCED: SMPS को forcefully reload करें अगर GPU available है
       
        // Force SMPS reload if both cabinet and GPU are available
        if (this.gpu?.model && this.cabinet?.model) {
          await loadSMPSBrandsForced();
        } else if (this.checkDependencies('smps')) {
          await loadSMPSBrandsForced();
        } else {
        }
        
        // Cooler reload करें
        if (this.checkDependencies('cooler')) {
          loadCoolerTypeForced();
        }
      },
      'gpu': async () => {
        // GPU change के बाद SMPS reload करें
        if (this.checkDependencies('smps')) {
          await loadSMPSBrandsForced();
        }
      },
      'processor': async () => {
        // Processor change के बाद motherboard reload करें
        if (this.checkDependencies('motherboard')) {
          await loadComponentBrands('motherboard');
        }
        // Cooler reload करें
        loadCoolerTypeForced();
      },
      'motherboard': async () => {
        // Motherboard change के बाद RAM reload करें
        if (this.checkDependencies('ram')) {
          await loadRAMBrands();
        }
      }
    };

    const reloadFn = reloadMap[changedComponent];
    if (reloadFn) {
      reloadFn.call(this);
    }
  };

  // ✅ FIXED: Better GPU Value Retrieval
  window.PCBuilderState.checkDependencies = function(component) {
    if (!dependencies[component]) return true;
    
    
    // ✅ ENHANCED: Multiple fallback sources for state
    let currentState = { ...this };
    
    // Try localStorage as backup
    const savedState = localStorage.getItem('pcBuilderState');
    if (savedState) {
      try {
        const parsedState = JSON.parse(savedState);
        // Merge saved state, prioritizing current state
        Object.keys(parsedState).forEach(key => {
          if (!currentState[key] || !currentState[key].model) {
            currentState[key] = parsedState[key];
          }
        });
      } catch (error) {
        console.error('Error parsing saved state:', error);
      }
    }
    
    for (let dep of dependencies[component]) {
      const [parent, child] = dep.split('.');
      const parentComponent = currentState[parent];
      
      if (!parentComponent || 
          !parentComponent[child] || 
          parentComponent[child] === null) {
        
        return false;
      }
      
    }
    
    return true;
  };

  // ======================================================================
  // SECTION 6: Helper Functions
  // ======================================================================
  function getComponentPrefix(component) {
    const prefixMap = {
      'cabinet': 'cabinet',
      'processor': 'processor',
      'motherboard': 'motherboard',
      'gpu': 'gpu',
      'primary-storage': 'primary-storage',
      'secondary-storage': 'secondary-storage',
      'optional-storage': 'optional-storage',
      'ram': 'ram',
      'cooler': 'cooler',
      'smps': 'smps',
      'os': 'os',
      'custom-mod': 'custom-mod'
    };
    return prefixMap[component] || component;
  }

  function getDropdownCount(component) {
    const counts = {
      'cabinet': 2,
      'processor': 3,
      'motherboard': 2,
      'gpu': 2,
      'primary-storage': 3,
      'secondary-storage': 3,
      'optional-storage': 3,
      'ram': 2,
      'cooler': 3,
      'smps': 2,
      'os': 1,
      'custom-mod': 3
    };
    return counts[component] || 2;
  }

  function getPlaceholder(component, index) {
    const placeholders = {
      'cabinet': ['Brand', 'Model'],
      'processor': ['Brand', 'Generation', 'Model'],
      'motherboard': ['Brand', 'Model'],
      'gpu': ['Brand', 'Model'],
      'primary-storage': ['Type', 'Brand', 'Model'],
      'secondary-storage': ['Type', 'Brand', 'Model'],
      'optional-storage': ['Type', 'Brand', 'Model'],
      'ram': ['Brand', 'Model'],
      'cooler': ['Type', 'Brand', 'Model'],
      'smps': ['Brand', 'Model'],
      'os': ['Select OS'],
      'custom-mod': ['Category', 'Brand', 'Model']
    };
    return placeholders[component][index - 1] || 'Option';
  }

  // ======================================================================
  // SECTION 7: Set Component Dependency State
  // ======================================================================
  window.PCBuilderState.setComponentDependencyState = function(component) {
    const prefix = getComponentPrefix(component);
    const canLoad = this.checkDependencies(component);
    
    
    const firstDropdown = document.querySelector(`#${prefix}1`);
    const firstInput = document.querySelector(`#${prefix}1 .custom-dropdown-input`);
    
    if (firstDropdown && firstInput) {
      if (!canLoad) {
        firstDropdown.classList.add('dependency-disabled');
        firstInput.disabled = true;
        firstInput.placeholder = `Select dependencies first`;
      } else {
        firstDropdown.classList.remove('dependency-disabled');
        firstInput.disabled = false;
        firstInput.placeholder = getPlaceholder(component, 1);
      }
    }
  };

  // ======================================================================
  // SECTION 8: Enum Loading
  // ======================================================================
  async function loadEnums() {
    try {
      const response = await fetch(apiEndpoints.enums, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const enumsData = await response.json();
      window.PCBuilderEnums = enumsData;
      
      return enumsData;
    } catch (error) {
      console.error('❌ Error loading enums:', error);
      
      const errorMessage = document.createElement('div');
      errorMessage.innerHTML = `
        <p style="color: red; text-align: center;">⚠️ Failed to load configuration options. Please check your internet and try again.</p>
        <button id="retry-enums" style="display: block; margin: 10px auto; padding: 8px 16px; background: #800be5; color: white; border: none; border-radius: 4px;">Retry</button>
      `;
      document.body.prepend(errorMessage);
      
      document.getElementById('retry-enums').addEventListener('click', async () => {
        errorMessage.remove();
        await loadEnums();
      });
      
      document.querySelectorAll('.custom-dropdown-input').forEach(input => {
        input.disabled = true;
        input.placeholder = 'Options unavailable - Retry loading';
      });
      
      return {};
    }
  }

  // ======================================================================
  // SECTION 9: Price Handling Functions
  // ======================================================================
  window.PCBuilderState.validatePrice = function (price) {
    const numPrice = parseFloat(price);
    if (isNaN(numPrice) || numPrice < 0) {
      return 0;
    }
    return numPrice;
  };
window.PCBuilderState.calculateTotalPrice = function() {
  let totalPrice = 0;
  
  // Handle custom mods first
  if (this.customMods) {
    this.customMods.forEach(mod => {
      if (mod.model) {
        totalPrice += this.validatePrice(mod.model.price || mod.model.selling_price || 0);
      }
    });
  }
  
  Object.keys(this).forEach(component => {
    const componentData = this[component];
    if (component === 'customMods' || !componentData || typeof componentData !== 'object') return;

    // ⚠️ CRITICAL FIX: Skip GPU price when GPU is skipped
    if (component === 'gpu' && this.gpuSkipped) {
      return; // Skip GPU price entirely
    }

    let price = 0;

    if (component === 'cooler' && this.storageChoices['cooler'] && componentData.model) {
      price = this.validatePrice(componentData.model.price || componentData.model.selling_price || 0);
    } else if (componentData.model) {
      price = this.validatePrice(componentData.model.price || componentData.model.selling_price || 0);
    }
    
    totalPrice += price;
  });
  
  return totalPrice;
};

  window.PCBuilderState.updateFinalPrice = function () {
    try {
      const totalPrice = this.calculateTotalPrice();

      const priceElement = document.getElementById('final-total-price');
      if (priceElement) {
        const formattedPrice =
          'INR ' + formatINR(totalPrice) +
          '<span style="font-size:12px; color: #800be5; font-weight: 500;">  (Inclusive of GST)</span>';

        priceElement.innerHTML = formattedPrice;
      }

      const floatingPriceElement = document.getElementById('floating-total-price');
      if (floatingPriceElement && priceElement) {
        floatingPriceElement.textContent = priceElement.textContent;
      }

          if (typeof refreshRazorpayWidget === 'function') {
      refreshRazorpayWidget(totalPrice);
    }

      return totalPrice;

    } catch (error) {
      console.error('❌ Error in price calculation:', error);
      return 0;
    }
  };

  // ======================================================================
  // SECTION 10: Component Display Names
  // ======================================================================
  window.PCBuilderState.getComponentDisplayName = function(component, componentData) {
    const baseNames = {
      'cabinet': 'Cabinet',
      'processor': 'Processor',
      'motherboard': 'Motherboard', 
      'gpu': 'Graphics Card',
      'primary-storage': 'Primary Storage',
      'secondary-storage': 'Secondary Storage',
      'optional-storage': 'Optional Storage',
      'ram': 'RAM',
      'cooler': 'Cooler',
      'smps': 'SMPS',
      'os': 'Operating System'
    };

    if (componentData && componentData.brand && componentData.brand.name) {
      const brandName = componentData.brand.name;
      const baseName = baseNames[component] || component;
      return `${brandName} ${baseName}`;
    }
    
    if (component === 'os') {
      return 'Operating System';
    }
    
    return baseNames[component] || component;
  };


// Custom Confirm Modal Function - Clean background के साथ
// Simple Custom Confirm Function
window.customConfirm = function(message, title = "Modal Title") {
  return new Promise((resolve) => {
    const modal = document.getElementById('customConfirmModal');
    const modalContent = document.getElementById('modalContent');
    const messageEl = document.getElementById('modalMessage');
    const titleEl = modalContent.querySelector('h3');
    const confirmBtn = document.getElementById('modalConfirm');
    const cancelBtn = document.getElementById('modalCancel');
    
    // Set content
    titleEl.textContent = title;
    messageEl.textContent = message;
    
    // Show modal
    modal.classList.remove('hidden');
    setTimeout(() => modal.classList.add('show'), 10);
    
    // Handle confirm
    const handleConfirm = () => {
      hideModal();
      resolve(true);
    };
    
    // Handle cancel
    const handleCancel = () => {
      hideModal();
      resolve(false);
    };
    
    // Hide modal
    const hideModal = () => {
      modal.classList.remove('show');
      setTimeout(() => {
        modal.classList.add('hidden');
        confirmBtn.removeEventListener('click', handleConfirm);
        cancelBtn.removeEventListener('click', handleCancel);
      }, 300);
    };
    
    // Add listeners
    confirmBtn.addEventListener('click', handleConfirm);
    cancelBtn.addEventListener('click', handleCancel);
  });
};



  // ======================================================================
  // SECTION 11: Build Review Functionality
  // ======================================================================
window.PCBuilderState.updateBuildReview = function() {
    const reviewTableBody = document.getElementById('review-table-body');
    const reviewTableContainer = document.getElementById('review-table-container');
    const noComponentsMessage = document.getElementById('no-components-message');
    
    if (!reviewTableBody || !reviewTableContainer || !noComponentsMessage) {
      return;
    }

    reviewTableBody.innerHTML = '';
    
    let hasComponents = false;
    let totalPrice = 0;

    // Define the specific order you want
    const componentOrder = [
        'cabinet',
        'processor', 
        'motherboard',
        'gpu',
        'smps',
        'primary-storage',
        'secondary-storage', 
        'optional-storage',
        'ram',
        'cooler',
    ];

    // Process components in the specified order
    componentOrder.forEach(component => {
        if (!this[component] || typeof this[component] !== 'object') {
            return;
        }

        const componentData = this[component];
        let selectedText = '';
        let price = 0;

        if (component === 'processor' && componentData.model) {
            const brand = componentData.brand?.name || '';
            const generation = componentData.generation?.name || '';
            const model = componentData.model?.name || '';
            selectedText = `${brand} ${generation} ${model}`.trim();
            price = this.validatePrice(componentData.model.price || componentData.model.selling_price || 0);
        } else if ((component.includes('storage') || component === 'cooler') && componentData.model) {
            const type = componentData.type?.name || '';
            const brand = componentData.brand?.name || '';
            const model = componentData.model?.name || '';
            selectedText = `${type} ${brand} ${model}`.trim();
            price = this.validatePrice(componentData.model.price || componentData.model.selling_price || 0);
        } 
        else if (component === 'cooler' && this.storageChoices && this.storageChoices['cooler'] && componentData.model) {
            const type = componentData.type?.name || '';
            const brand = componentData.brand?.name || '';
            const model = componentData.model?.name || '';
            selectedText = `${type} ${brand} ${model}`.trim();
            price = this.validatePrice(componentData.model.price || componentData.model.selling_price || 0);
        }
        else if (componentData.model) {
            const brand = componentData.brand?.name || '';
            const model = componentData.model?.name || '';
            selectedText = `${brand} ${model}`.trim();
            price = this.validatePrice(componentData.model.price || componentData.model.selling_price || 0);
        }

        if (selectedText) {
            hasComponents = true;
            totalPrice += price;
            
            const displayName = this.getComponentDisplayName(component, componentData);
            
            const row = document.createElement('tr');
            row.className = 'border-b border-gray-100';
            row.innerHTML = `
              <td class="py-3 px-4 text-[13px]">${selectedText}</td>
              <td class="py-3 px-4 border-l border-l-gray-100 text-[13px] text-right font-semibold">${price >= 0 ? formatINR(price) : 'SELECTED MOTHERBOARD HAS INBUILT WIFI AND BLUETOOTH'}</td>
            `;
            reviewTableBody.appendChild(row);
        }
    });

    // Process custom mods after all main components
    if (this.customMods && Array.isArray(this.customMods)) {
        this.customMods.forEach((mod, index) => {
            if (mod.model) {
                hasComponents = true;
                const category = mod.category?.name || '';
                const brand = mod.brand?.name || '';
                const model = mod.model?.name || '';
                const selectedText = `${category} ${brand} ${model}`.trim();
                const price = this.validatePrice(mod.model.price || mod.model.selling_price || 0);
                totalPrice += price;

                const row = document.createElement('tr');
                row.className = 'border-b border-gray-200';
                row.innerHTML = `
                  <td class="py-3 px-4 text-black text-[13px]">${selectedText}</td>
                  <td class="py-3 px-4  border-l border-l-gray-100 text-right text-[13px] font-semibold">${formatINR(price)}</td>
                `;
                reviewTableBody.appendChild(row);
            }
        });
    }

    if (this.os?.model) {
        const componentData = this.os;
        let selectedText = '';
        let price = 0;

        selectedText = componentData.model.name;
        price = this.validatePrice(componentData.model.price || componentData.model.selling_price || 0);

        if (selectedText) {
            hasComponents = true;
            totalPrice += price;
            
            const displayName = this.getComponentDisplayName('os', componentData);
            
            const row = document.createElement('tr');
            row.className = 'border-b border-gray-100';
            row.innerHTML = `
              <td class="py-3 px-4 text-[13px]">${selectedText}</td>
              <td class="py-3 px-4 border-l border-l-gray-100 text-[13px] text-right font-semibold">${price >= 0 ? formatINR(price) : 'SELECTED MOTHERBOARD HAS INBUILT WIFI AND BLUETOOTH'}</td>
            `;
            reviewTableBody.appendChild(row);
        }
    }

    if (hasComponents) {
        noComponentsMessage.style.display = 'none';
        reviewTableContainer.style.display = 'block';
    } else {
        noComponentsMessage.style.display = 'block';
        reviewTableContainer.style.display = 'none';
    }
};

  // ======================================================================
  // SECTION 12: UI Restore from localStorage
  // ======================================================================
  async function restoreUIFromState() {
    const state = window.PCBuilderState;
    
    try {
      // Cabinet restore
      if (state.cabinet?.brand?.name) {
        const brandInput = document.querySelector('#cabinet1 .custom-dropdown-input');
        if (brandInput) {
          updateInputDisplay(brandInput, state.cabinet.brand, false);
          brandInput.disabled = false;
        }
      }
      
      if (state.cabinet?.model?.name) {
        const modelInput = document.querySelector('#cabinet2 .custom-dropdown-input');
        if (modelInput) {
          updateInputDisplay(modelInput, state.cabinet.model, true);
          modelInput.disabled = false;
        }
      }
      if (state.cabinet?.model?.images) {
        updateProductImages(state.cabinet.model.images);
    }

      // GPU restore
      if (state.gpu?.brand?.name) {
        const brandInput = document.querySelector('#gpu1 .custom-dropdown-input');
        if (brandInput) {
          updateInputDisplay(brandInput, state.gpu.brand, false);
          brandInput.disabled = false;
        }
      }
      
      if (state.gpu?.model?.name) {
        const modelInput = document.querySelector('#gpu2 .custom-dropdown-input');
        if (modelInput) {
          updateInputDisplay(modelInput, state.gpu.model, true);
          modelInput.disabled = false;
        }
      }

      
      // OS restore
      if (state.os?.model?.name) {
        const osInput = document.querySelector('#os1 .custom-dropdown-input');
        if (osInput) {
          updateInputDisplay(osInput, state.os.model, true);
          osInput.disabled = false;
        }
      }

      state.updateFinalPrice();
      state.updateBuildReview();
      state.checkFinalAddToCartStatus();

    } catch (error) {
      console.error('❌ Error restoring UI:', error);
    }
  }

  // ======================================================================
  // SECTION 13: Populate Options Function
  // ======================================================================
  function populateOptions(input, optionsList, options, onSelectCallback, showPrice = false, requireConfirmation = false, componentName = null) {
    try {
      optionsList.innerHTML = '';

      if (!options || options.length === 0) {
        const noOptionsLi = document.createElement('li');
        noOptionsLi.textContent = 'No options available';
        noOptionsLi.style.cssText = 'padding: 12px; color: #6b7280; font-style: italic; text-align: center;';
        optionsList.appendChild(noOptionsLi);
        return;
      }

      options.forEach((opt, index) => {
        if (!opt || typeof opt !== 'object') return;

        const li = document.createElement('li');
        li.style.cssText = `
          cursor: pointer; font-size: 16px; display: flex; justify-content: space-between;
          align-items: center; padding: 12px 16px; border-bottom: 1px solid #e5e7eb;
          transition: all 0.2s ease; color: #374151;
        `;

        li.addEventListener('mouseenter', () => li.style.backgroundColor = '#f9fafb');
        li.addEventListener('mouseleave', () => li.style.backgroundColor = 'transparent');

        const nameSpan = document.createElement('span');
        const isCabinetModel = input.closest('[id*="cabinet2"]') || (input.id.includes('cabinet') && input.id.includes('2'));
            if (isCabinetModel && opt.type) {
                const typeLabel = getCabinetTypeLabel(opt.type);
                nameSpan.textContent = `${opt.name} - (${typeLabel})`;
            } else {
                nameSpan.textContent = opt.name;
            }
        nameSpan.style.cssText = 'flex: 1; font-weight: 600; color: #000000; font-size: 14px; margin-right: 8px;';
        li.appendChild(nameSpan);

        if (showPrice && opt.displayPrice > 0) {
          const priceSpan = document.createElement('span');
          priceSpan.textContent = `+${formatINR(opt.displayPrice)}`;
          priceSpan.style.cssText = `
            font-weight: 600; color: #000000; 
            padding: 4px 8px; border-radius: 6px; font-size: 14px;
            min-width: 80px; text-align: center;
          `;
          li.appendChild(priceSpan);
        }

        li.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (li.classList.contains('selecting')) return;
          li.classList.add('selecting');

          try {
            // ✅ Smart Confirmation Logic
            // Smart Confirmation Logic
if (requireConfirmation && componentName) {
    const affectedComponents = window.PCBuilderState.getAffectedComponentsWithSelections(componentName);
    if (affectedComponents.length > 0) {
        const componentDisplayName = componentName.charAt(0).toUpperCase() + componentName.slice(1).replace('-', ' ');
        const dependentNames = affectedComponents.map(dep => dep.charAt(0).toUpperCase() + dep.slice(1).replace('-', ' ')).join(', ');
      let message;
if (componentName === 'cabinet') {
    message = 'Cabinet change may reset motherboard, cooler & SMPS. Do you want to continue?';
} else if (componentName === 'gpu') {
    message = 'GPU Change may need SMPS Upgrade. Do you want to continue?';
} else if (componentName === 'processor') {
    message = 'Processor change may reset motherboard, RAM & cooler. Do you want to continue?';
} else if (componentName === 'motherboard') {
    message = 'Motherboard change may require new RAM selection. Do you want to continue?';
    
}
else if (componentName === 'smps' && window.PCBuilderState.smpsNeedsGPUCheck) {
    message = 'GPU selection was recently enabled. SMPS selection may need compatibility verification. Do you want to continue?';
    
    // Clear the flag after confirmation (regardless of user choice)
    window.PCBuilderState.smpsNeedsGPUCheck = false;
}
else {
    message = `Changing ${componentDisplayName} will reset the following already selected components: ${dependentNames}. Do you want to continue?`;
}


        const userConfirmed = await customConfirm(message);
        if (!userConfirmed) {
            optionsList.style.display = 'none';
            li.classList.remove('selecting');
            return;
        }
    }
}


            optionsList.querySelectorAll('li').forEach(item => {
              item.classList.remove('selected');
              item.classList.remove('selecting');
            });
            li.classList.add('selected');

            updateInputDisplay(input, opt, showPrice);
            optionsList.style.display = 'none';

            setTimeout(async () => {
              try {
                if (onSelectCallback && typeof onSelectCallback === 'function') {
                  await onSelectCallback(opt);
                }
              } catch (error) {
                console.error('❌ Error in option callback:', error);
              } finally {
                li.classList.remove('selecting');
              }
            }, 50);

          } catch (error) {
            console.error('❌ Error in option selection:', error);
            li.classList.remove('selecting');
          }
        });

        optionsList.appendChild(li);
      });
    } catch (error) {
      console.error('❌ Error populating options:', error);
    }
  }

  function getCabinetTypeLabel(typeId) {
    const cabinetTypes = window.PCBuilderEnums?.cabinet_model_types || [
        {value: 1, label: "Mini-ITX"},
        {value: 2, label: "Micro ATX"}, 
        {value: 3, label: "ATX"},
        {value: 4, label: "EATX"}
    ];
    
    const foundType = cabinetTypes.find(type => 
        type.value === typeId || 
        type.value === typeId.toString() || 
        type.value === parseInt(typeId)
    );
    
    return foundType ? foundType.label : `Type ${typeId}`;
}

  // ======================================================================
  // SECTION 14: Update Input Display Function
  // ======================================================================
  function updateInputDisplay(input, option, showPrice) {
    try {
      const existingDisplay = input.parentNode.querySelector('.selected-display');
      if (existingDisplay) {
        existingDisplay.remove();
      }

      input.style.display = '';
      input.readOnly = false;
      input.value = option.name || '';

      const display = document.createElement('div');
      display.className = 'selected-display';
      display.style.cssText = `
        display: flex; justify-content: space-between; 
        align-items: center; padding: 6px;
        border: 1px solid #7B7C7E; border-radius: 8px;
        background: #ffffff; cursor: pointer;
        font-size: 12px; transition: all 0.2s ease;
        position: relative; z-index: 1;
      `;

      let displayText = option.name;
       const isCabinetModel = input.closest('[id*="cabinet2"]') || input.id.includes('cabinet') && input.id.includes('2');
        if (isCabinetModel && option.type) {
            const typeLabel = getCabinetTypeLabel(option.type);
            displayText = `${option.name} - (${typeLabel})`;
        }
      display.innerHTML = `
        <span style="flex:1; color:#000000; font-weight:600;">${displayText}</span>
        ${showPrice && option.displayPrice > 0
          ? `<span style="font-weight:600; color:#000000;">+${formatINR(option.displayPrice)}</span>`
          : ''}
      `;
      

      input.style.display = 'none';
      input.parentNode.appendChild(display);

      const clickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (!input.disabled) {
          const optionsList = input.parentNode.querySelector('.custom-dropdown-options');
          if (optionsList) {
            const isVisible = optionsList.style.display === 'block';
            
            document.querySelectorAll('.custom-dropdown-options').forEach(otherList => {
              if (otherList !== optionsList) {
                otherList.style.display = 'none';
              }
            });
            
            if (isVisible) {
              optionsList.style.display = 'none';
            } else {
              optionsList.style.display = 'block';
              optionsList.classList.add('opening');
            }
          }
        }
      };

      display.removeEventListener('click', clickHandler);
      display.addEventListener('click', clickHandler);

      display.addEventListener('mouseenter', () => {
        display.style.borderColor = '#d1d5db';
      });
      display.addEventListener('mouseleave', () => {
        display.style.borderColor = '#7B7C7E';
      });

      const changeEvent = new Event('change', { bubbles: true });
      input.dispatchEvent(changeEvent);

    } catch (error) {
      console.error('❌ Error updating input display:', error);
    }
  }

  // ======================================================================
  // SECTION 15: Dropdown Interaction Setup
  // ======================================================================
  function setupDropdownInteractions(dropdown, input, optionsList) {
    const existingHandlers = input._pcBuilderHandlers || {};
    
    if (existingHandlers.clickHandler) {
      input.removeEventListener('click', existingHandlers.clickHandler);
    }
    if (existingHandlers.inputHandler) {
      input.removeEventListener('input', existingHandlers.inputHandler);
    }

    const clickHandler = (e) => {
      e.preventDefault();
      if (input.disabled) return;

      const display = input.parentNode.querySelector('.selected-display');
      if (display) {
        return;
      }

      const isVisible = optionsList.style.display === 'block';
      
      document.querySelectorAll('.custom-dropdown-options').forEach(otherList => {
        if (otherList !== optionsList) {
          otherList.style.display = 'none';
          otherList.classList.remove('opening');
        }
      });

      if (isVisible) {
        optionsList.style.display = 'none';
        optionsList.classList.remove('opening');
      } else {
        optionsList.style.display = 'block';
        optionsList.classList.add('opening');
        
        input.readOnly = false;
        input.focus();
      }
    };

    const inputHandler = (e) => {
      const search = input.value.toLowerCase().trim();
      Array.from(optionsList.children).forEach(li => {
        const text = li.textContent.toLowerCase();
        li.style.display = text.includes(search) ? 'flex' : 'none';
      });
    };

    input.addEventListener('click', clickHandler);
    input.addEventListener('input', inputHandler);
    
    input._pcBuilderHandlers = { clickHandler, inputHandler };

    const outsideClickHandler = (e) => {
      if (!dropdown.contains(e.target)) {
        optionsList.style.display = 'none';
        optionsList.classList.remove('opening');
      }
    };

    if (dropdown._outsideClickHandler) {
      document.removeEventListener('click', dropdown._outsideClickHandler);
    }
    
    document.addEventListener('click', outsideClickHandler);
    dropdown._outsideClickHandler = outsideClickHandler;
  }

  // ======================================================================
  // SECTION 16: Component Loading Functions
  // ======================================================================

  // Type Selection Functions
  function loadTypeOptions(component) {
    const prefix = getComponentPrefix(component);
    const typeInput = document.querySelector(`#${prefix}1 .custom-dropdown-input`);
    const typeOptionsList = document.querySelector(`#${prefix}1 .custom-dropdown-options`);

    if (!typeInput || !typeOptionsList) return;

    typeInput.disabled = false;
    typeInput.placeholder = 'Type';

    let enumOptions = [];
    if (component.includes('storage')) {
      enumOptions = window.PCBuilderEnums.storage_types || [];
      enumOptions.sort((a, b) => b.value - a.value);
    } else if (component === 'cooler') {
      enumOptions = window.PCBuilderEnums.cooler_types || [];
      
      const processorModel = window.PCBuilderState.processor?.model;
      if (processorModel && processorModel.is_stock_cooler === 0) {
        enumOptions = enumOptions.filter(option => option.value !== 3);
      }
    }

    const typeOptions = enumOptions.map(option => ({
      id: option.value,
      name: option.label
    }));

    populateOptions(typeInput, typeOptionsList, typeOptions, async (type) => {
      for (let i = 2; i <= getDropdownCount(component); i++) {
        const input = document.querySelector(`#${prefix}${i} .custom-dropdown-input`);
        const options = document.querySelector(`#${prefix}${i} .custom-dropdown-options`);
        
        if (input) {
          input.value = '';
          input.disabled = true;
          input.placeholder = getPlaceholder(component, i);
          const display = input.parentNode.querySelector('.selected-display');
          if (display) {
            display.remove();
            input.style.display = '';
          }
        }
        if (options) options.innerHTML = '';
      }

      window.PCBuilderState[component].type = type;
      window.PCBuilderState[component].brand = null;
      window.PCBuilderState[component].model = null;
      window.PCBuilderState.saveToLocalStorage();

      if (component.includes('storage')) {
        await loadStorageBrands(component, type);
      } else if (component === 'cooler') {
        await loadCoolerBrands();
      }
    }, false);
  }

  // Storage Loading Functions
  async function loadStorageBrands(component, type) {
    const prefix = getComponentPrefix(component);
    const brandInput = document.querySelector(`#${prefix}2 .custom-dropdown-input`);
    const brandOptionsList = document.querySelector(`#${prefix}2 .custom-dropdown-options`);

    if (!brandInput || !brandOptionsList) return;

    brandInput.disabled = false;
    brandInput.placeholder = 'Loading brands...';
    brandInput.classList.add('loading');
      const storageTypeValue = window.PCBuilderState[component]?.type?.id || '';

    try {
     const res = await fetch(
  `${apiEndpoints[component].brands}${type.id}&storage_type=${storageTypeValue}`,
  {
    headers: {
      'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
);

      const json = await res.json();
      const brands = json.data?.data || json.data || [];

      brandInput.classList.remove('loading');

      if (brands.length === 0) {
        brandInput.placeholder = 'No brands available';
        return;
      }

      populateOptions(brandInput, brandOptionsList, brands, async (brand) => {
        const modelInput = document.querySelector(`#${prefix}3 .custom-dropdown-input`);
        const modelOptions = document.querySelector(`#${prefix}3 .custom-dropdown-options`);

        if (modelInput) {
          modelInput.value = '';
          modelInput.disabled = false;
          modelInput.placeholder = 'Loading models...';
          const display = modelInput.parentNode.querySelector('.selected-display');
          if (display) {
            display.remove();
            modelInput.style.display = '';
          }
        }
        if (modelOptions) modelOptions.innerHTML = '';

        window.PCBuilderState[component].brand = brand;
        window.PCBuilderState[component].model = null;
        window.PCBuilderState.saveToLocalStorage();
        await loadStorageModels(component, brand);
      }, false);

      brandInput.placeholder = 'Brand';
    } catch (error) {
      console.error(`❌ Error loading ${component} brands:`, error);
      brandInput.classList.remove('loading');
    }
  }

  async function loadStorageModels(component, brand) {
    const prefix = getComponentPrefix(component);
    const modelInput = document.querySelector(`#${prefix}3 .custom-dropdown-input`);
    const modelOptionsList = document.querySelector(`#${prefix}3 .custom-dropdown-options`);

    if (!modelInput || !modelOptionsList) return;

    modelInput.classList.add('loading');

    try {
      const storageTypeValue = window.PCBuilderState[component]?.type?.id || '';
      const res = await fetch(`${apiEndpoints[component].models}${brand.id}&storage_type=${storageTypeValue}`, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const json = await res.json();
      let models = json.data?.data || json.data || [];

      models = models.map(model => {
        model.displayPrice = window.PCBuilderState.validatePrice(model.price || model.selling_price || 0);
        return model;
      });

      modelInput.classList.remove('loading');

      if (models.length === 0) {
        modelInput.placeholder = 'No models available';
        return;
      }

      populateOptions(modelInput, modelOptionsList, models, async (model) => {
        window.PCBuilderState[component].model = model;
        window.PCBuilderState.saveToLocalStorage();
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.updateBuildReview();
      }, true);

      modelInput.placeholder = 'Model';
    } catch (error) {
      console.error(`❌ Error loading ${component} models:`, error);
      modelInput.classList.remove('loading');
    }
  }

 async function loadComponentBrands(component) {
  const prefix = getComponentPrefix(component);
  const brandIndex = component.includes('storage') || component === 'cooler' ? 2 : 1;
  const brandInput = document.querySelector(`#${prefix}${brandIndex} .custom-dropdown-input`);
  const brandOptionsList = document.querySelector(`#${prefix}${brandIndex} .custom-dropdown-options`);
  
  if (!brandInput || !brandOptionsList) return;

  // SMPS SPECIAL CASE - CABINET & GPU DEPENDENCY CHECK
  if (component === 'smps') {
    let cabinetId = window.PCBuilderState.cabinet?.model?.id;
    let graphicId = window.PCBuilderState.gpu?.model?.id;
    
    // Fallback to localStorage
    if (!cabinetId || !graphicId) {
      const savedState = localStorage.getItem('pcBuilderState');
      if (savedState) {
        try {
          const parsedState = JSON.parse(savedState);
          cabinetId = cabinetId || parsedState.cabinet?.model?.id;
          graphicId = graphicId || parsedState.gpu?.model?.id;
        } catch (error) {
          console.error('Error parsing saved state:', error);
        }
      }
    }
    
    if (!cabinetId || !graphicId) {
      brandInput.disabled = true;
      brandInput.placeholder = 'Select Cabinet & GPU first';
      return;
    }
    
    brandInput.disabled = false;
    brandInput.placeholder = 'Loading brands...';
    brandInput.classList.add('loading');
    
    try {
      // API call with both IDs for SMPS brands
      const apiUrl = `${apiEndpoints.smps.brands}cabinetid=${cabinetId}&graphic_card_id=${graphicId}`;
      const res = await fetch(apiUrl, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      const json = await res.json();
      const brandOptions = json.data?.data || json.data;
      
      brandInput.classList.remove('loading');
      
      if (brandOptions.length === 0) {
        brandInput.placeholder = 'No brands available';
        return;
      }
      
      populateOptions(brandInput, brandOptionsList, brandOptions, async (brand) => {
        // Reset model dropdown
        const modelInput = document.querySelector('#smps2 .custom-dropdown-input');
        const modelOptions = document.querySelector('#smps2 .custom-dropdown-options');
        
        if (modelInput) {
          modelInput.value = '';
          modelInput.disabled = false;
          modelInput.placeholder = 'Loading models...';
          
          const display = modelInput.parentNode.querySelector('.selected-display');
          if (display) display.remove();
          modelInput.style.display = '';
        }
        
        if (modelOptions) {
          modelOptions.innerHTML = '';
        }
        
        window.PCBuilderState.smps.brand = brand;
        window.PCBuilderState.smps.model = null;
        window.PCBuilderState.saveToLocalStorage();
        
        await loadSMPSModels(brand);
      }, false, true, 'smps');
      
      brandInput.placeholder = 'Brand';
      
    } catch (error) {
      console.error('Error loading SMPS brands:', error);
      brandInput.classList.remove('loading');
    }
    return; // Exit early for SMPS
  }

  // MOTHERBOARD SPECIAL CASE - GENERATION_ID & PROCESSOR_ID DEPENDENCY CHECK
if (component === 'motherboard') {
  let generationId = window.PCBuilderState.processor?.generation?.id;
  let processorId = window.PCBuilderState.processor?.model?.id;
  let cabinetModelType = window.PCBuilderState.cabinet?.model?.type;
  const cabinetId = window.PCBuilderState?.cabinet?.model?.id;

  
  // Fallback to localStorage
  if (!generationId || !processorId) {
    const savedState = localStorage.getItem('pcBuilderState');
    if (savedState) {
      try {
        const parsedState = JSON.parse(savedState);
        generationId = generationId || parsedState.processor?.generation?.id;
        processorId = processorId || parsedState.processor?.model?.id;
      } catch (error) {
        console.error('Error parsing saved state:', error);
      }
    }
  }
  if (!generationId || !processorId) {
    brandInput.disabled = true;
    brandInput.placeholder = 'Select Processor first';
    return;
  }
  
  brandInput.disabled = false;
  brandInput.placeholder = 'Loading brands...';
  brandInput.classList.add('loading');
  
  try {
    // API call with both IDs for Motherboard brands
    let apiUrl = `${apiEndpoints.motherboard.brands}generation_id=${generationId}&processor_id=${processorId}`; 
    if (cabinetModelType === 1) {
  apiUrl += `&cabinet_id=${cabinetId}`;
}
    const res = await fetch(apiUrl, {
      headers: {
        'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    const json = await res.json();
    const brandOptions = json.data?.data || json.data;
    
    brandInput.classList.remove('loading');
    
    if (brandOptions.length === 0) {
      brandInput.placeholder = 'No brands available';
      return;
    }
    
    populateOptions(brandInput, brandOptionsList, brandOptions, async (brand) => {
      // Reset model dropdown
      const modelIndex = getDropdownCount(component);
      const modelInput = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-input`);
      const modelOptions = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-options`);

      if (modelInput) {
        modelInput.value = '';
        modelInput.disabled = false;
        modelInput.placeholder = 'Loading models...';
        
        const display = modelInput.parentNode.querySelector('.selected-display');
        if (display) display.remove();
        modelInput.style.display = '';
      }

      if (modelOptions) {
        modelOptions.innerHTML = '';
      }
      
      const resetConfirmed = await window.PCBuilderState.smartResetDependentComponents('motherboard');
      
      if (!resetConfirmed) {
        // User cancelled, revert selection
        brandInput.value = window.PCBuilderState.motherboard?.brand?.name || '';
        return;
      }

      window.PCBuilderState.motherboard.brand = brand;
      window.PCBuilderState.motherboard.model = null;
      window.PCBuilderState.saveToLocalStorage();

      await loadMotherboardModels(brand);
      
      // RELOAD DEPENDENT COMPONENTS ON BRAND CHANGE
      setTimeout(async () => {
        if (window.PCBuilderState.checkDependencies('ram')) {
          await loadRAMBrands();
        }
      }, 100);
      
    }, false);
    
    brandInput.placeholder = 'Brand';
    
  } catch (error) {
    console.error('Error loading Motherboard brands:', error);
    brandInput.classList.remove('loading');
  }
  return; // Exit early for Motherboard
}


  // REST OF GENERIC CODE FOR OTHER COMPONENTS
  if (!window.PCBuilderState.checkDependencies(component)) {
    window.PCBuilderState.setComponentDependencyState(component);
    return;
  }

  brandInput.disabled = false;
  brandInput.placeholder = 'Loading brands...';
  brandInput.classList.add('loading');

  try {
    const res = await fetch(apiEndpoints[component].brands, {
      headers: {
        'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    const json = await res.json();
    const brandOptions = json.data?.data || json.data;
    
    brandInput.classList.remove('loading');
    
    if (brandOptions.length === 0) {
      brandInput.placeholder = 'No brands available';
      return;
    }

    populateOptions(brandInput, brandOptionsList, brandOptions, async (brand) => {
      // BRAND CHANGE - DEPENDENCY RELOAD STARTS HERE
      if (component === 'processor') {
        // Reset generation and model dropdowns
        const generationInput = document.querySelector('#processor2 .custom-dropdown-input');
        const modelInput = document.querySelector('#processor3 .custom-dropdown-input');
        const generationOptions = document.querySelector('#processor2 .custom-dropdown-options');
        const modelOptions = document.querySelector('#processor3 .custom-dropdown-options');

        if (generationInput) {
          generationInput.value = '';
          generationInput.disabled = false;
          generationInput.placeholder = 'Loading generations...';
          
          const display = generationInput.parentNode.querySelector('.selected-display');
          if (display) display.remove();
          generationInput.style.display = '';
        }

        if (modelInput) {
          modelInput.value = '';
          modelInput.disabled = true;
          modelInput.placeholder = 'Generation';
          
          const display = modelInput.parentNode.querySelector('.selected-display');
          if (display) display.remove();
          modelInput.style.display = '';
        }

        if (generationOptions) generationOptions.innerHTML = '';
        if (modelOptions) modelOptions.innerHTML = '';
const resetConfirmed = await window.PCBuilderState.smartResetDependentComponents('processor');

if (!resetConfirmed) {
    // User cancelled, revert selection
    brandInput.value = window.PCBuilderState.processor?.brand?.name || '';
    return;
}
        window.PCBuilderState.processor.brand = brand;
        window.PCBuilderState.processor.generation = null;
        window.PCBuilderState.processor.model = null;
        window.PCBuilderState.saveToLocalStorage();
        
        await loadProcessorGenerations(brand);
        
        // RELOAD DEPENDENT COMPONENTS ON BRAND CHANGE
        setTimeout(async () => {
           await loadComponentBrands('cabinet');
          if (window.PCBuilderState.checkDependencies('motherboard')) {
            await loadComponentBrands('motherboard');
          }
          if (window.PCBuilderState.checkDependencies('cooler')) {
            await loadComponentBrands('cooler');
          }
        }, 100);
        
      } else if (component === 'cabinet') {
        // Reset model dropdown
        const modelIndex = getDropdownCount(component);
        const modelInput = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-input`);
        const modelOptions = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-options`);

        if (modelInput) {
          modelInput.value = '';
          modelInput.disabled = false;
          modelInput.placeholder = 'Loading models...';
          
          const display = modelInput.parentNode.querySelector('.selected-display');
          if (display) display.remove();
          modelInput.style.display = '';
        }

        if (modelOptions) {
          modelOptions.innerHTML = '';
        }
        if (component === 'cabinet') {
    const resetConfirmed = await window.PCBuilderState.smartResetDependentComponents('cabinet');
    
    if (!resetConfirmed) {
        // User cancelled, revert selection
        brandInput.value = window.PCBuilderState.cabinet?.brand?.name || '';
        return;
    }
}

        window.PCBuilderState[component].brand = brand;
        window.PCBuilderState[component].model = null;
        window.PCBuilderState.saveToLocalStorage();

        await loadComponentModels(component, brand);
        
        // RELOAD DEPENDENT COMPONENTS ON BRAND CHANGE
        setTimeout(async () => {
          if (window.PCBuilderState.checkDependencies('motherboard')) {
            await loadComponentBrands('motherboard');
          }
          if (window.PCBuilderState.checkDependencies('smps')) {
            await loadSMPSBrandsForced();
          }
          if (window.PCBuilderState.checkDependencies('cooler')) {
            await loadComponentBrands('cooler');
          }
        }, 100);
        
      } else if (component === 'gpu') {
        // Reset model dropdown
        const modelIndex = getDropdownCount(component);
        const modelInput = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-input`);
        const modelOptions = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-options`);

        if (modelInput) {
          modelInput.value = '';
          modelInput.disabled = false;
          modelInput.placeholder = 'Loading models...';
          
          const display = modelInput.parentNode.querySelector('.selected-display');
          if (display) display.remove();
          modelInput.style.display = '';
        }

        if (modelOptions) {
          modelOptions.innerHTML = '';
        }

         const resetConfirmed = await window.PCBuilderState.smartResetDependentComponents('gpu');
    
    if (!resetConfirmed) {
        // User cancelled, revert selection
        brandInput.value = window.PCBuilderState.gpu?.brand?.name || '';
        return;
    }
        
        window.PCBuilderState[component].brand = brand;
        window.PCBuilderState[component].model = null;
        window.PCBuilderState.saveToLocalStorage();

        await loadComponentModels(component, brand);
        
        // RELOAD DEPENDENT COMPONENTS ON BRAND CHANGE
        setTimeout(async () => {
          if (window.PCBuilderState.checkDependencies('smps')) {
            await loadSMPSBrandsForced();
          }
        }, 100);
        
      } else if (component === 'motherboard') {
        // Reset model dropdown
        const modelIndex = getDropdownCount(component);
        const modelInput = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-input`);
        const modelOptions = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-options`);

        if (modelInput) {
          modelInput.value = '';
          modelInput.disabled = false;
          modelInput.placeholder = 'Loading models...';
          
          const display = modelInput.parentNode.querySelector('.selected-display');
          if (display) display.remove();
          modelInput.style.display = '';
        }

        if (modelOptions) {
          modelOptions.innerHTML = '';
        }
        const resetConfirmed = await window.PCBuilderState.smartResetDependentComponents('motherboard');
    
    if (!resetConfirmed) {
        // User cancelled, revert selection
        brandInput.value = window.PCBuilderState.motherboard?.brand?.name || '';
        return;
    }

        window.PCBuilderState[component].brand = brand;
        window.PCBuilderState[component].model = null;
        window.PCBuilderState.saveToLocalStorage();

        if (component === 'motherboard') {
          await loadMotherboardModels(brand);
        } else {
          await loadComponentModels(component, brand);
        }
        
        // RELOAD DEPENDENT COMPONENTS ON BRAND CHANGE
        setTimeout(async () => {
          if (window.PCBuilderState.checkDependencies('ram')) {
            await loadRAMBrands();
          }
        }, 100);
        
      } else {
        // Generic handling for other components
        const modelIndex = getDropdownCount(component);
        const modelInput = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-input`);
        const modelOptions = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-options`);

        if (modelInput) {
          modelInput.value = '';
          modelInput.disabled = false;
          modelInput.placeholder = 'Loading models...';
          
          const display = modelInput.parentNode.querySelector('.selected-display');
          if (display) display.remove();
          modelInput.style.display = '';
        }

        if (modelOptions) {
          modelOptions.innerHTML = '';
        }

        

        window.PCBuilderState[component].brand = brand;
        window.PCBuilderState[component].model = null;
        window.PCBuilderState.saveToLocalStorage();

        await loadComponentModels(component, brand);
      }
    }, false);

    brandInput.placeholder = 'Brand';
    
    const firstDropdown = document.querySelector(`#${prefix}${brandIndex}`);
    if (firstDropdown) {
      firstDropdown.classList.remove('dependency-disabled');
    }
    
  } catch (error) {
    console.error('Error loading component brands:', error);
    brandInput.classList.remove('loading');
  }
}

  

async function loadComponentModels(component, brand) {
    const prefix = getComponentPrefix(component);
    const modelIndex = getDropdownCount(component);
    const modelInput = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-input`);
    const modelOptionsList = document.querySelector(`#${prefix}${modelIndex} .custom-dropdown-options`);


    if (!modelInput || !modelOptionsList) return;


    modelInput.classList.add('loading');


    try {
      let apiUrl = apiEndpoints[component].models + brand.id;


      const res = await fetch(apiUrl, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });


      const json = await res.json();
      let modelOptions = json.data?.data || json.data || [];


      modelOptions = modelOptions.map(model => {
        model.displayPrice = window.PCBuilderState.validatePrice(model.price || model.selling_price || 0);
        return model;
      });


      modelInput.classList.remove('loading');


      if (modelOptions.length === 0) {
        modelInput.placeholder = 'No models available';
        return;
      }


      // ✅ Smart Confirmation for components with dependents
     const requireConfirmation = ['cabinet', 'gpu', 'processor', 'motherboard'].includes(component) && 
                            window.PCBuilderState.getAffectedComponentsWithSelections && 
                            window.PCBuilderState.getAffectedComponentsWithSelections(component).length > 0;



      populateOptions(modelInput, modelOptionsList, modelOptions, async (model) => {
        window.PCBuilderState[component].model = model;
        window.PCBuilderState.saveToLocalStorage();
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.updateBuildReview();
        
        if(component === 'gpu'){
          setTimeout(async () => {
  if (window.PCBuilderState.checkDependencies('smps')) {
    await loadSMPSBrandsForced();
  }
}, 100);
        }


        if (component === 'cabinet'){
          const selectedMb = window.PCBuilderState.motherboard?.model;
  if (selectedMb) {
    checkMotherboardCabinetCompatibility(selectedMb);
  }


          setTimeout(async () => {
  if (window.PCBuilderState.checkDependencies('motherboard')) {
    await loadComponentBrands('motherboard');
  }
  if (window.PCBuilderState.checkDependencies('smps')) {
    await loadSMPSBrandsForced();
  }
  if (window.PCBuilderState.checkDependencies('cooler')) {
    await loadComponentBrands('cooler');
  }
}, 100);
        }
        // ✅ Smart reset dependent components
        if (component === 'cabinet' || component === 'gpu') {
          // ✅ Cabinet change par SMPS compatibility check
          if (component === 'cabinet') {
            // Check if SMPS is compatible with new cabinet type
            const newCabinetType = model.type; // Newly selected cabinet model ka type
            const currentSMPS = window.PCBuilderState.smps?.model;
            
            if (currentSMPS && currentSMPS.cabinet_size_ids && Array.isArray(currentSMPS.cabinet_size_ids)) {
              // Check compatibility
              const isCompatible = currentSMPS.cabinet_size_ids.includes(newCabinetType) ||
                                  currentSMPS.cabinet_size_ids.includes(newCabinetType.toString()) ||
                                  currentSMPS.cabinet_size_ids.includes(parseInt(newCabinetType));
              
              if (isCompatible) {
                return; // ❌ Don't call smartResetDependentComponents
              } else {
                // ✅ Proceed with reset
              }
            }
          }
          
          window.PCBuilderState.smartResetDependentComponents(component);
        }
      }, true, component);


      modelInput.placeholder = 'Model';
    } catch (error) {
      console.error(`❌ Error loading ${component} models:`, error);
      modelInput.classList.remove('loading');
    }
  }


  // Specific loading functions for processor, motherboard, SMPS, RAM, etc.
async function loadProcessorGenerations(brand) {
    const generationInput = document.querySelector('#processor2 .custom-dropdown-input');
    const generationOptionsList = document.querySelector('#processor2 .custom-dropdown-options');
    
    if (!generationInput || !generationOptionsList) return;
    
    generationInput.disabled = false;
    generationInput.placeholder = "Loading generations...";
    generationInput.classList.add('loading');
    
    try {
        const res = await fetch(`${apiEndpoints.processor.generations}${brand.id}`, {
            headers: {
                'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const json = await res.json();
        const generations = json.data?.data || json.data;
        
        generationInput.classList.remove('loading');
        
        if (generations.length === 0) {
            generationInput.placeholder = "No generations available";
            return;
        }
        
        // ENHANCED POPULATE OPTIONS WITH MOTHERBOARD COMPATIBILITY CHECK
        populateOptions(generationInput, generationOptionsList, generations, async generation => {
            
            // CHECK IF THREADRIPPER GENERATION IS SELECTED
            if (generation.id === 18 || generation.id === 19) {
                // THREADRIPPER LOGIC REMAINS SAME
                const cabinetType = window.PCBuilderState.cabinet?.model?.type;
                if (cabinetType !== 4) {
                    try {
                        const userConfirmed = await customConfirm(
                            "Please select an E-ATX cabinet to proceed with the Threadripper build", 
                            "E-ATX Cabinet Required"
                        );
                        
                        if (userConfirmed) {
                            // Cabinet reset
                            window.PCBuilderState.cabinet = { brand: null, model: null };
                            resetCabinetUI();
                            window.PCBuilderState.saveToLocalStorage();
                            
                            // Processor flow continue
                            const modelInput = document.querySelector('#processor3 .custom-dropdown-input');
                            const modelOptions = document.querySelector('#processor3 .custom-dropdown-options');
                            
                            if (modelInput) {
                                modelInput.value = "";
                                modelInput.disabled = false;
                                modelInput.placeholder = "Loading models...";
                                const display = modelInput.parentNode.querySelector('.selected-display');
                                if (display) display.remove();
                                modelInput.style.display = "";
                            }
                            if (modelOptions) {
                                modelOptions.innerHTML = "";
                            }
                            
                            window.PCBuilderState.processor.generation = generation;
                            window.PCBuilderState.processor.model = null;
                            window.PCBuilderState.saveToLocalStorage();
                            
                            await window.PCBuilderState.smartResetDependentComponents('processor');
                            await loadProcessorModels(brand, generation);
                            
                            setTimeout(async () => {
                                await loadCabinetBrandsWithType(4);
                            }, 100);
                        } else {
                            // User cancelled - revert
                            generationInput.value = "";
                            const display = generationInput.parentNode.querySelector('.selected-display');
                            if (display) display.remove();
                            generationInput.style.display = "";
                            window.PCBuilderState.processor.generation = null;
                            window.PCBuilderState.processor.model = null;
                            window.PCBuilderState.saveToLocalStorage();
                            
                            const modelInput = document.querySelector('#processor3 .custom-dropdown-input');
                            const modelOptions = document.querySelector('#processor3 .custom-dropdown-options');
                            if (modelInput) {
                                modelInput.value = "";
                                modelInput.disabled = true;
                                modelInput.placeholder = "Generation";
                                const modelDisplay = modelInput.parentNode.querySelector('.selected-display');
                                if (modelDisplay) modelDisplay.remove();
                                modelInput.style.display = "";
                            }
                            if (modelOptions) {
                                modelOptions.innerHTML = "";
                            }
                            return;
                        }
                    } catch (error) {
                        console.error("Error in Threadripper cabinet check:", error);
                        return;
                    }
                } else {
                    // E-ATX CABINET ALREADY SELECTED - NORMAL FLOW
                    const modelInput = document.querySelector('#processor3 .custom-dropdown-input');
                    const modelOptions = document.querySelector('#processor3 .custom-dropdown-options');
                    
                    if (modelInput) {
                        modelInput.value = "";
                        modelInput.disabled = false;
                        modelInput.placeholder = "Loading models...";
                        const display = modelInput.parentNode.querySelector('.selected-display');
                        if (display) display.remove();
                        modelInput.style.display = "";
                    }
                    if (modelOptions) {
                        modelOptions.innerHTML = "";
                    }
                    
                    window.PCBuilderState.processor.generation = generation;
                    window.PCBuilderState.processor.model = null;
                    window.PCBuilderState.saveToLocalStorage();
                    
                    await window.PCBuilderState.smartResetDependentComponents('processor');
                    await loadProcessorModels(brand, generation);
                }
            } else {
                // NON-THREADRIPPER GENERATION - WITH MOTHERBOARD COMPATIBILITY CHECK
                
                // NEW CONDITION: Check motherboard compatibility
                const selectedMotherboard = window.PCBuilderState.motherboard?.model;
                if (selectedMotherboard && selectedMotherboard.processor_generation_ids) {
                    const isCompatible = selectedMotherboard.processor_generation_ids.includes(generation.id.toString());
                    
                    if (isCompatible) {
                        // COMPATIBLE GENERATION - NO CONFIRM AND NO RESET
                        
                        // Regular generation flow
                        const modelInput = document.querySelector('#processor3 .custom-dropdown-input');
                        const modelOptions = document.querySelector('#processor3 .custom-dropdown-options');
                        
                        if (modelInput) {
                            modelInput.value = "";
                            modelInput.disabled = false;
                            modelInput.placeholder = "Loading models...";
                            const display = modelInput.parentNode.querySelector('.selected-display');
                            if (display) display.remove();
                            modelInput.style.display = "";
                        }
                        if (modelOptions) {
                            modelOptions.innerHTML = "";
                        }
                        
                        // State save
                        window.PCBuilderState.processor.generation = generation;
                        window.PCBuilderState.processor.model = null;
                        window.PCBuilderState.saveToLocalStorage();
                        
                        // SKIP smartResetDependentComponents for compatible generation
                        await loadProcessorModels(brand, generation);
                        
                        return; // EXIT early - no reset needed
                    }
                }
                
                // INCOMPATIBLE OR NO MOTHERBOARD - PROCEED WITH NORMAL FLOW
                const modelInput = document.querySelector('#processor3 .custom-dropdown-input');
                const modelOptions = document.querySelector('#processor3 .custom-dropdown-options');
                
                if (modelInput) {
                    modelInput.value = "";
                    modelInput.disabled = false;
                    modelInput.placeholder = "Loading models...";
                    const display = modelInput.parentNode.querySelector('.selected-display');
                    if (display) display.remove();
                    modelInput.style.display = "";
                }
                if (modelOptions) {
                    modelOptions.innerHTML = "";
                }
                
                // State save
                window.PCBuilderState.processor.generation = generation;
                window.PCBuilderState.processor.model = null;
                window.PCBuilderState.saveToLocalStorage();
                
                // CONDITIONAL RESET - only if incompatible motherboard exists
                if (selectedMotherboard) {
                    await window.PCBuilderState.smartResetDependentComponents('processor');
                }
                
                await loadProcessorModels(brand, generation);
                
                // Reload dependent components for non-threadripper
                setTimeout(async () => {
                   await loadComponentBrands('cabinet');
                    if (window.PCBuilderState.checkDependencies('motherboard')) {
                        await loadComponentBrands('motherboard');
                    }
                    if (window.PCBuilderState.checkDependencies('cooler')) {
                        await loadComponentBrands('cooler');
                    }
                }, 100);
            }
        }, false, "processor");
        
        generationInput.placeholder = "Generation";
        
    } catch (error) {
        console.error("Error loading processor generations:", error);
        generationInput.classList.remove('loading');
    }
}





  async function loadProcessorModels(brand, generation) {
    const modelInput = document.querySelector('#processor3 .custom-dropdown-input');
    const modelOptionsList = document.querySelector('#processor3 .custom-dropdown-options');

    if (!modelInput || !modelOptionsList) return;

    modelInput.classList.add('loading');

    try {
      const res = await fetch(`${apiEndpoints.processor.models}${brand.id}&generation_id=${generation.id}`, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const json = await res.json();
      let models = json.data?.data || json.data || [];

      models = models.map(model => {
        model.displayPrice = window.PCBuilderState.validatePrice(model.price || model.selling_price || 0);
        return model;
      });

      modelInput.classList.remove('loading');

      if (models.length === 0) {
        modelInput.placeholder = 'No models available';
        return;
      }

      const requireConfirmation = window.PCBuilderState.getAffectedComponentsWithSelections && 
                            window.PCBuilderState.getAffectedComponentsWithSelections('processor').length > 0;


      populateOptions(modelInput, modelOptionsList, models, async (model) => {
 const selectedMotherboard = window.PCBuilderState.motherboard?.model;
if (selectedMotherboard && selectedMotherboard.excluded_processor_model_ids) {
    // Check if model is EXCLUDED (incompatible)
    const isExcluded = selectedMotherboard.excluded_processor_model_ids.includes(model.id.toString());
    
    if (isExcluded) {
        // INCOMPATIBLE MODEL - RESET MOTHERBOARD
        
        // Reset motherboard and dependent components
        await window.PCBuilderState.smartResetDependentComponents('processor');
        
        // Continue with normal processor model flow after reset
        window.PCBuilderState.processor.model = model;
        window.PCBuilderState.saveToLocalStorage();
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.updateBuildReview();
        
        return; // EXIT after reset
    }
}


 const hasMotherboardBrand = window.PCBuilderState.motherboard?.brand;
    
    if (hasMotherboardBrand) {
        
        // Save processor model first
        window.PCBuilderState.processor.model = model;
        window.PCBuilderState.saveToLocalStorage();
        
        // Refresh motherboard models with new processor context
        setTimeout(async () => {
            if (window.PCBuilderState.checkDependencies('motherboard')) {
                const motherboardBrand = window.PCBuilderState.motherboard.brand;
                await loadMotherboardModels(motherboardBrand);
            }
        }, 100);
    }



        
        window.PCBuilderState.processor.model = model;
         window.PCBuilderState.saveToLocalStorage();
    window.PCBuilderState.updateFinalPrice();
    window.PCBuilderState.checkFinalAddToCartStatus();
    window.PCBuilderState.updateBuildReview();

        // After window.PCBuilderState.processor.model = model;
const coolerRadioContainer = document.getElementById('cooler-radio-container');
const stockCoolerMessage = document.getElementById('stock-cooler-message');
// Always reset cooler radio to Yes so visual and storageChoices stay in sync
// when a new processor model is selected (previous restore may have set No)
const _coolerYesRadio = document.querySelector('input[name="cooler-choice"][value="yes"]');
const _coolerNoRadio  = document.querySelector('input[name="cooler-choice"][value="no"]');
if (_coolerYesRadio) _coolerYesRadio.checked = true;
if (_coolerNoRadio)  _coolerNoRadio.checked  = false;

if (model && model.is_stock_cooler === 1) {
  coolerRadioContainer.style.display = 'flex';
  if (stockCoolerMessage) stockCoolerMessage.style.display = 'inline';
  window.PCBuilderState.storageChoices['cooler'] = true;
  document.getElementById('cooler-fields').classList.add('storage-fields-visible');
  document.getElementById('cooler-fields').classList.remove('storage-fields-hidden');
} else {
  coolerRadioContainer.style.display = 'none';
  window.PCBuilderState.storageChoices['cooler'] = true;
  document.getElementById('cooler-fields').classList.add('storage-fields-visible');
  document.getElementById('cooler-fields').classList.remove('storage-fields-hidden');
}
loadCoolerTypeForced();  // Add this to load options
// Existing: saveToLocalStorage(), updateFinalPrice(), etc.

        window.PCBuilderState.saveToLocalStorage();
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.updateBuildReview();

        setTimeout(async () => {
          if (window.PCBuilderState.checkDependencies('motherboard')) {
            await loadComponentBrands('motherboard');
          }
        }, 100);
        
        // ✅ Smart reset for processor
        // window.PCBuilderState.smartResetDependentComponents('processor');
      }, true, 'processor');

      modelInput.placeholder = 'Model';
    } catch (error) {
      console.error('❌ Error loading processor models:', error);
      modelInput.classList.remove('loading');
    }
  }

  // ✅ FIXED: Enhanced SMPS Loading Function
  async function loadSMPSModels(brand) {
    const modelInput = document.querySelector('#smps2 .custom-dropdown-input');
    const modelOptionsList = document.querySelector('#smps2 .custom-dropdown-options');

    if (!modelInput || !modelOptionsList) return;

    modelInput.classList.add('loading');

    try {
      const brandId = brand.id;
      
      // ✅ ENHANCED: Multiple sources for GPU and Cabinet IDs
      let cabinetId = '';
      let graphicId = '';
      
      // Try current state first
      if (window.PCBuilderState.cabinet?.model?.id) {
        cabinetId = window.PCBuilderState.cabinet.model.id;
      }
      if (window.PCBuilderState.gpu?.model?.id) {
        graphicId = window.PCBuilderState.gpu.model.id;
      }
      
      // Fallback to localStorage
      if (!cabinetId || !graphicId) {
        const savedState = localStorage.getItem('pcBuilderState');
        if (savedState) {
          try {
            const parsedState = JSON.parse(savedState);
            cabinetId = cabinetId || parsedState.cabinet?.model?.id || '';
            graphicId = graphicId || parsedState.gpu?.model?.id || '';
          } catch (error) {
            console.error('Error parsing saved state for SMPS:', error);
          }
        }
      }

      
      // ✅ VALIDATION: Check if we have required dependencies
      if (!cabinetId || !graphicId) {
        // GPU is skipped — delegate to the no-GPU variant instead of failing
        if (window.PCBuilderState.gpuSkipped && cabinetId) {
          modelInput.classList.remove('loading');
          return await window.PCBuilderState.loadSMPSModelsWithoutGPU(brand);
        }
        console.warn(`❌ SMPS loading failed - Missing dependencies: cabinet=${cabinetId}, gpu=${graphicId}`);
        modelInput.classList.remove('loading');
        modelInput.placeholder = 'Select Cabinet & GPU first';
        modelInput.disabled = true;
        return;
      }

      const apiUrl = `${apiEndpoints.smps.models}${brandId}&cabinet_id=${cabinetId}&graphic_card_id=${graphicId}`;

      const res = await fetch(apiUrl, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const json = await res.json();
      let models = json.data?.data || json.data || [];

      models = models.map(model => {
        model.displayPrice = window.PCBuilderState.validatePrice(model.price || model.selling_price || 0);
        return model;
      });

      modelInput.classList.remove('loading');

      if (models.length === 0) {
        modelInput.placeholder = 'No models available';
        return;
      }

      populateOptions(modelInput, modelOptionsList, models, async (model) => {
        window.PCBuilderState.smps.model = model;
        window.PCBuilderState.saveToLocalStorage();
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.updateBuildReview();
      }, true);

      modelInput.placeholder = 'Model';
      modelInput.disabled = false;
      
    } catch (error) {
      console.error('❌ Error loading SMPS models:', error);
      modelInput.classList.remove('loading');
    }
  }


  // New function to update main product image and thumbnails
function updateProductImages(imagesArray) {
    try {
        const mainImage = document.getElementById('main-pc-image');
        const thumbnailContainer = document.querySelector('.flex.justify-center.lg\\:justify-start.gap-2');
        
        if (!mainImage || !thumbnailContainer || !imagesArray?.length) return;
        
        // Update main image - use first image as featured
        const mainImageUrl = imagesArray[0].url || imagesArray[0];
        mainImage.src = mainImageUrl;
        mainImage.setAttribute('data-default-src', mainImageUrl);
        
        // Update thumbnails gallery
        thumbnailContainer.innerHTML = '';
        
        // Create thumbnails (limit to 4 as per original design)
        imagesArray.slice(0, 4).forEach((image, index) => {
            const imageUrl = image.url || image; // Handle both object and string formats
            const thumbnailUrl = imageUrl.replace('1000x1000', '100x100'); // Thumbnail size
            
            const thumbnailDiv = document.createElement('div');
            thumbnailDiv.className = `cursor-pointer transition-all duration-200 hover:scale-105 flex-shrink-0 ${
                index === 0 ? 'opacity-100' : 'opacity-70'
            }`;
            thumbnailDiv.onclick = () => changeProductImage(imageUrl, thumbnailDiv);
            
            const thumbnailImg = document.createElement('img');
            thumbnailImg.src = thumbnailUrl;
            thumbnailImg.alt = `Selected Cabinet View ${index + 1}`;
            thumbnailImg.className = `w-16 h-16 sm:w-18 sm:h-18 lg:w-20 lg:h-20 rounded-lg bg-[#eaeaea] object-contain p-1 sm:p-2 border-2 transition-all duration-200 ${
                index === 0 
                    ? 'border-[#800be5] shadow-[0_0_0_2px_rgba(128,11,229,0.3)]' 
                    : 'border-transparent hover:border-[#800be5]'
            }`;
            
            thumbnailDiv.appendChild(thumbnailImg);
            thumbnailContainer.appendChild(thumbnailDiv);
        });
        
    } catch (error) {
        console.error('Error updating product images:', error);
    }
}
// STEP 1: Enhanced Compatibility Function with Enum Mapping
function checkMotherboardCabinetCompatibility(motherboardModel) {
    try {
        // Get current cabinet model
        const cabinetModel = window.PCBuilderState.cabinet?.model;
        
        if (!cabinetModel || !motherboardModel) {
            clearMotherboardCompatibilityWarning();
            return true;
        }
        
        // Check if cabinet type ID exists in motherboard's cabinet_size_ids array
        const cabinetTypeId = cabinetModel.type;
        const motherboardCabinetSizeIds = motherboardModel.cabinet_size_ids || [];
        
   
        // Multiple type checking for API consistency
        const isCompatible = motherboardCabinetSizeIds.includes(cabinetTypeId) || 
                            motherboardCabinetSizeIds.includes(cabinetTypeId.toString()) ||
                            motherboardCabinetSizeIds.includes(parseInt(cabinetTypeId));
        
        if (!isCompatible) {
            // ✅ GET CABINET SIZE NAMES FROM ENUM
            const compatibleSizeNames = getCompatibleCabinetSizeNames(motherboardCabinetSizeIds);
            const currentCabinetSizeName = getCabinetSizeNameById(cabinetTypeId);
            
            // Show compact warning with size names
            showMotherboardCompatibilityWarning(
                motherboardModel.name,
                currentCabinetSizeName,
                compatibleSizeNames
            );
            return true; // Continue execution
        } else {
            // Clear warning if compatible
            clearMotherboardCompatibilityWarning();
            return false;
        }
        
    } catch (error) {
        console.error('Error checking motherboard-cabinet compatibility:', error);
        clearMotherboardCompatibilityWarning();
        return true;
    }
}

// ✅ HELPER FUNCTIONS FOR ENUM MAPPING
function getCabinetSizeNameById(typeId) {
    try {
        const cabinetTypes = window.PCBuilderEnums?.cabinet_model_types || [];
        const foundType = cabinetTypes.find(type => 
            type.value == typeId || 
            type.value == typeId.toString() || 
            type.value == parseInt(typeId)
        );
        return foundType ? foundType.label : `Type ${typeId}`;
    } catch (error) {
        console.error('Error getting cabinet size name:', error);
        return `Type ${typeId}`;
    }
}

function getCompatibleCabinetSizeNames(sizeIds) {
    try {
        const cabinetTypes = window.PCBuilderEnums?.cabinet_model_types || [];
        const compatibleNames = [];
        
        sizeIds.forEach(sizeId => {
            const foundType = cabinetTypes.find(type => 
                type.value == sizeId || 
                type.value == sizeId.toString() || 
                type.value == parseInt(sizeId)
            );
            if (foundType) {
                compatibleNames.push(foundType.label);
            }
        });
        
        return compatibleNames.length > 0 ? compatibleNames.join(' / ') : 'Compatible sizes';
    } catch (error) {
        console.error('Error getting compatible size names:', error);
        return 'Compatible sizes';
    }
}


// ✅ COMPACT WARNING DISPLAY WITH SIZE NAMES
function showMotherboardCompatibilityWarning(motherboardName, currentCabinetSize, compatibleSizes) {
    // Clear any existing warning
    clearMotherboardCompatibilityWarning();
    
    // Find motherboard section
    const motherboardSection = document.querySelector('motherboard2')?.closest('.section') ||
                              document.querySelector('motherboard2')?.parentElement ||
                              document.querySelector('[id*="motherboard"]');
    
    if (!motherboardSection) {
        console.error('Motherboard section not found');
        return;
    }
    
    // Create compact warning element
    const warningDiv = document.createElement('div');
    warningDiv.id = 'motherboard-compatibility-warning';
    warningDiv.className = 'compatibility-warning-message';
    warningDiv.style.cssText = `
        background: white;
        border: 2px solid #800be5;
        border-radius: 6px;
        padding: 8px 12px;
        margin: 6px 0;
        color: black;
        font-size: 13px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 8px;
        animation: slideInCompact 0.3s ease-out;
        box-shadow: 0 2px 4px rgba(245, 158, 11, 0.15);
        line-height: 1.3;
    `;
    
    // Compact message with size information
    warningDiv.innerHTML = `
       <svg width="20" height="20" viewBox="0 0 20 20" style="flex-shrink: 0;">
  <!-- Purple background -->
  <path 
    fill="#800BE5" 
    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92z"
  />
  <!-- White exclamation mark -->
  <path 
    fill="#FFFFFF" 
    d="M10 13a1 1 0 100-2 1 1 0 000 2zm0-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
  />
</svg>

        <div style="flex: 1;">
            <div style="font-weight: 700; margin-bottom: 2px;">
                Size mismatch: Motherboard only supports  <strong>${compatibleSizes}</strong>Cabinet
            </div>
            <div style="font-size: 11px; color: #black;">
                Selected motherboard needs compatible cabinet size
            </div>
        </div>
    `;
    
    // Insert warning after motherboard dropdown
    const motherboardDropdown = motherboardSection.querySelector('motherboard2') || 
                                motherboardSection.querySelector('.custom-dropdown');
    
    if (motherboardDropdown && motherboardDropdown.parentNode) {
        motherboardDropdown.parentNode.insertBefore(warningDiv, motherboardDropdown.nextSibling);
    } else {
        motherboardSection.appendChild(warningDiv);
    }
}

// ✅ CLEAR WARNING FUNCTION
function clearMotherboardCompatibilityWarning() {
    const existingWarning = document.getElementById('motherboard-compatibility-warning');
    if (existingWarning) {
        existingWarning.style.animation = 'slideOut 0.2s ease-in';
        setTimeout(() => {
            if (existingWarning.parentNode) {
                existingWarning.remove();
            }
        }, 200);
    }
}

  // Motherboard Loading with enhanced dependency check
  async function loadMotherboardModels(brand) {
    const modelInput = document.querySelector('#motherboard2 .custom-dropdown-input');
    const modelOptionsList = document.querySelector('#motherboard2 .custom-dropdown-options');

    if (!modelInput || !modelOptionsList) return;

    modelInput.classList.add('loading');

    try {
      const brandId = brand.id;
      const generationId = window.PCBuilderState.processor?.generation?.id || '';
      const processorId = window.PCBuilderState.processor?.model?.id || '';
      const cabinetModelType = window.PCBuilderState?.cabinet?.model?.type;
      const cabinetId = window.PCBuilderState?.cabinet?.model?.id;

      let apiUrl = `${apiEndpoints.motherboard.models}${brandId}&generation_id=${generationId}&processor_id=${processorId}`;

      if(cabinetModelType === 1 ){
        apiUrl += `&cabinet_id=${cabinetId}`; 
      }

      const res = await fetch(apiUrl, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const json = await res.json();
      let models = json.data?.data || json.data || [];

      models = models.map(model => {
        model.displayPrice = window.PCBuilderState.validatePrice(model.price || model.selling_price || 0);
        return model;
      });

      modelInput.classList.remove('loading');

      if (models.length === 0) {
        modelInput.placeholder = 'No models available';
        return;
      }

      const requireConfirmation = window.PCBuilderState.getAffectedComponentsWithSelections && 
                            window.PCBuilderState.getAffectedComponentsWithSelections('motherboard').length > 0;


      populateOptions(modelInput, modelOptionsList, models, async (model) => {
         checkMotherboardCabinetCompatibility(model);
        window.PCBuilderState.motherboard.model = model;
        window.PCBuilderState.saveToLocalStorage();
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.updateBuildReview();
      setTimeout(async () => {
  if (window.PCBuilderState.checkDependencies('ram')) {
    await loadRAMBrands();
  }
}, 100);
        
        window.PCBuilderState.smartResetDependentComponents('motherboard');
      }, true, 'motherboard');

      modelInput.placeholder = 'Model';
    } catch (error) {
      console.error('❌ Error loading motherboard models:', error);
      modelInput.classList.remove('loading');
    }
  }

  // RAM Loading Functions
  // ENHANCED RAM Loading Functions with Force Enable
async function loadRAMBrands() {
    const brandInput = document.querySelector('#ram1 .custom-dropdown-input');
    const brandOptionsList = document.querySelector('#ram1 .custom-dropdown-options');
    
    if (!brandInput || !brandOptionsList) return;
    
    // Force check dependencies
    const motherboardId = window.PCBuilderState.motherboard?.model?.id;
    
    // Fallback to localStorage if current state missing
    let fallbackMotherboardId = null;
    if (!motherboardId) {
        const savedState = localStorage.getItem('pcBuilderState');
        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);
                fallbackMotherboardId = parsedState.motherboard?.model?.id;
            } catch (error) {
                console.error('Error parsing saved state:', error);
            }
        }
    }
    
    const finalMotherboardId = motherboardId || fallbackMotherboardId;
    
    if (!finalMotherboardId) {
        brandInput.disabled = true;
        brandInput.placeholder = 'Select Motherboard first';
        return;
    }
    
    // FORCE ENABLE regardless of dependency check
    brandInput.disabled = false;
    brandInput.placeholder = 'Loading brands...';
    brandInput.classList.add('loading');
    
    try {
        const res = await fetch(
            `${apiEndpoints.ram.brands}&motherboard_id=${finalMotherboardId}`,
            {
                headers: {
                    'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }
        );
        
        const json = await res.json();
        const brands = json.data?.data || json.data || [];
        
        brandInput.classList.remove('loading');
        
        if (brands.length === 0) {
            brandInput.placeholder = 'No brands available';
            return;
        }
        
        populateOptions(brandInput, brandOptionsList, brands, async (brand) => {
            const modelInput = document.querySelector('#ram2 .custom-dropdown-input');
            const modelOptions = document.querySelector('#ram2 .custom-dropdown-options');
            
            if (modelInput) {
                modelInput.value = '';
                modelInput.disabled = false;
                modelInput.placeholder = 'Loading models...';
                
                const display = modelInput.parentNode.querySelector('.selected-display');
                if (display) display.remove();
                modelInput.style.display = '';
            }
            
            if (modelOptions) {
                modelOptions.innerHTML = '';
            }
            
            window.PCBuilderState.ram.brand = brand;
            window.PCBuilderState.ram.model = null;
            window.PCBuilderState.saveToLocalStorage();
            
            await loadRAMModels(brand);
        }, false);
        
        brandInput.placeholder = 'Brand';
        
        // Force remove dependency disabled class
        const firstDropdown = document.querySelector('#ram1');
        if (firstDropdown) {
            firstDropdown.classList.remove('dependency-disabled');
        }
        
    } catch (error) {
        console.error('❌ Error loading RAM brands:', error);
        brandInput.classList.remove('loading');
        brandInput.placeholder = 'Error loading brands';
    }
}


// Update the existing loadSMPSBrandsForced function
async function loadSMPSBrandsForced() {
    // **CHECK GPU SKIP STATE FIRST**
    if (window.PCBuilderState.gpuSkipped) {
        return await window.PCBuilderState.reloadSMPSWithoutGPU();
    }
    
    // **ORIGINAL LOGIC FOR NON-SKIPPED GPU**
    const brandInput = document.querySelector('#smps1 .custom-dropdown-input');
    const brandOptionsList = document.querySelector('#smps1 .custom-dropdown-options');
    
    if (!brandInput || !brandOptionsList) return;
    
    let cabinetId = window.PCBuilderState.cabinet?.model?.id;
    let graphicId = window.PCBuilderState.gpu?.model?.id;
    
    // Fallback to localStorage if needed
    if (!cabinetId || !graphicId) {
        const savedState = localStorage.getItem('pcBuilderState');
        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);
                cabinetId = cabinetId || parsedState.cabinet?.model?.id;
                graphicId = graphicId || parsedState.gpu?.model?.id;
            } catch (error) {
                console.error('Error parsing saved state for SMPS:', error);
            }
        }
    }
    
    if (!cabinetId || !graphicId) {
        brandInput.disabled = true;
        brandInput.placeholder = 'Select Cabinet & GPU first';
        return;
    }
    
    // Continue with existing SMPS loading logic...
    // (rest of the existing function remains the same)
    brandInput.disabled = false;
    brandInput.placeholder = 'Loading brands...';
    brandInput.classList.add('loading');
    
    try {
        // **API call with BOTH IDs for normal case**
        const apiUrl = `${apiEndpoints.smps.brands}?cabinetid=${cabinetId}&graphiccardid=${graphicId}`;
        const res = await fetch(apiUrl, {
            headers: {
                'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        
        const json = await res.json();
        const brandOptions = json.data?.data || json.data;
        
        brandInput.classList.remove('loading');
        
        if (brandOptions.length === 0) {
            brandInput.placeholder = 'No brands available';
            return;
        }
        
        populateOptions(brandInput, brandOptionsList, brandOptions, async (brand) => {
            // Reset model dropdown
            const modelInput = document.querySelector('#smps2 .custom-dropdown-input');
            const modelOptions = document.querySelector('#smps2 .custom-dropdown-options');
            
            if (modelInput) {
                modelInput.value = '';
                modelInput.disabled = false;
                modelInput.placeholder = 'Loading models...';
                const display = modelInput.parentNode.querySelector('.selected-display');
                if (display) {
                    display.remove();
                    modelInput.style.display = '';
                }
            }
            if (modelOptions) {
                modelOptions.innerHTML = '';
            }
            
            window.PCBuilderState.smps.brand = brand;
            window.PCBuilderState.smps.model = null;
            window.PCBuilderState.saveToLocalStorage();
            
            await loadSMPSModels(brand); // Use existing function for GPU-dependent loading
        }, false);
        
        brandInput.placeholder = 'Brand';
         const firstDropdown = document.querySelector('#smps1');
      if (firstDropdown) {
        firstDropdown.classList.remove('dependency-disabled');
      }
    } catch (error) {
        console.error('Error loading SMPS brands with dependencies:', error);
        brandInput.classList.remove('loading');
    }
}



// 📍 Updated `loadCabinetBrandsWithType` function - brand selection callback को update करें
async function loadCabinetBrandsWithType(type) {
    const brandInput = document.querySelector('#cabinet1 .custom-dropdown-input');
    const brandOptionsList = document.querySelector('#cabinet1 .custom-dropdown-options');

    if (!brandInput || !brandOptionsList) return;

    
    brandInput.disabled = false;
    brandInput.placeholder = 'Loading E-ATX brands...';
    brandInput.classList.add('loading');

    try {
        // API call with type parameter
        const apiUrl = `${apiEndpoints.cabinet.brands}?type=${type}`;
        
        const res = await fetch(apiUrl, {
            headers: {
                'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        const json = await res.json();
        const brandOptions = json.data?.data || json.data;

        brandInput.classList.remove('loading');

        if (brandOptions.length === 0) {
            brandInput.placeholder = 'No E-ATX brands available';
            return;
        }

        populateOptions(brandInput, brandOptionsList, brandOptions, async (brand) => {
            // Reset model dropdown
            const modelInput = document.querySelector('#cabinet2 .custom-dropdown-input');
            const modelOptions = document.querySelector('#cabinet2 .custom-dropdown-options');

            if (modelInput) {
                modelInput.value = '';
                modelInput.disabled = false;
                modelInput.placeholder = 'Loading E-ATX models...';

                const display = modelInput.parentNode.querySelector('.selected-display');
                if (display) {
                    display.remove();
                    modelInput.style.display = '';
                }
            }

            if (modelOptions) {
                modelOptions.innerHTML = '';
            }

            // Handle cabinet change with dependency reset
            const resetConfirmed = await window.PCBuilderState.smartResetDependentComponents('cabinet');
            if (!resetConfirmed) {
                // User cancelled, revert selection
                brandInput.value = window.PCBuilderState.cabinet?.brand?.name || '';
                return;
            }

            window.PCBuilderState.cabinet.brand = brand;
            window.PCBuilderState.cabinet.model = null;
            window.PCBuilderState.saveToLocalStorage();

            // 🔥 CORRECTED: brand_id और type दोनों parameters के साथ models load करें
            await loadCabinetModelsWithType(brand, type);

            // Reload dependent components
            setTimeout(async () => {
                if (window.PCBuilderState.checkDependencies('motherboard')) {
                    await loadComponentBrands('motherboard');
                }
                if (window.PCBuilderState.checkDependencies('smps')) {
                    await loadSMPSBrandsForced();
                }
                if (window.PCBuilderState.checkDependencies('cooler')) {
                    await loadComponentBrands('cooler');
                }
            }, 100);

        }, false);

        brandInput.placeholder = 'Brand';

    } catch (error) {
        console.error('Error loading E-ATX cabinet brands:', error);
        brandInput.classList.remove('loading');
        brandInput.placeholder = 'Error loading brands';
    }
}

// 📍 Updated `loadCabinetModelsWithType` function 
async function loadCabinetModelsWithType(brand, type) {
    const modelInput = document.querySelector('#cabinet2 .custom-dropdown-input');
    const modelOptionsList = document.querySelector('#cabinet2 .custom-dropdown-options');

    if (!modelInput || !modelOptionsList) return;

    modelInput.classList.add('loading');

    try {
        // 🔥 CORRECTED API call - brand_id और type parameter दोनों के साथ
        // Existing format: `${apiEndpoints.cabinet.models}${brand.id}`
        // Updated format: `${apiEndpoints.cabinet.models}${brand.id}&type=${type}`
        
        const apiUrl = `${apiEndpoints.cabinet.models}${brand.id}&type=${type}`;
        
        const res = await fetch(apiUrl, {
            headers: {
                'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        const json = await res.json();
        let modelOptions = json.data?.data || json.data;

        // Add display price
        modelOptions = modelOptions.map(model => {
            model.displayPrice = window.PCBuilderState.validatePrice(model.price || model.sellingprice || 0);
            return model;
        });

        modelInput.classList.remove('loading');

        if (modelOptions.length === 0) {
            modelInput.placeholder = 'No E-ATX models available';
            return;
        }

        populateOptions(modelInput, modelOptionsList, modelOptions, async (model) => {
            window.PCBuilderState.cabinet.model = model;
            window.PCBuilderState.saveToLocalStorage();

            // Update price and reviews
            window.PCBuilderState.updateFinalPrice();
            window.PCBuilderState.checkFinalAddToCartStatus();
            window.PCBuilderState.updateBuildReview();


    //         if (model.images && model.images.length > 0) {
    //           console.log(" i found images");
    //     updateProductImages(model.images);
    // }
     window.PCBuilderState.updateCabinetImages();

            // Reload dependent components after cabinet model selection
            setTimeout(async () => {
                if (window.PCBuilderState.checkDependencies('motherboard')) {
                    await loadComponentBrands('motherboard');
                }
                if (window.PCBuilderState.checkDependencies('smps')) {
                    await loadSMPSBrandsForced();
                }
                if (window.PCBuilderState.checkDependencies('cooler')) {
                    await loadComponentBrands('cooler');
                }
            }, 100);

        }, true);

        modelInput.placeholder = 'Model';

    } catch (error) {
        console.error('Error loading E-ATX cabinet models:', error);
        modelInput.classList.remove('loading');
        modelInput.placeholder = 'Error loading models';
    }
}


// 📍 यह function लगभग line 3500 के आस-पास add करें
function resetCabinetUI() {
    
    // Reset brand dropdown
    const brandInput = document.querySelector('#cabinet1 .custom-dropdown-input');
    const brandOptions = document.querySelector('#cabinet1 .custom-dropdown-options');
    
    if (brandInput) {
        brandInput.value = '';
        brandInput.disabled = false;
        brandInput.placeholder = 'Brand';
        
        // Remove fake display
        const display = brandInput.parentNode.querySelector('.selected-display');
        if (display) {
            display.remove();
            brandInput.style.display = '';
        }
    }
    
    if (brandOptions) {
        brandOptions.innerHTML = '';
        brandOptions.style.display = 'none';
    }
    
    // Reset model dropdown
    const modelInput = document.querySelector('#cabinet2 .custom-dropdown-input');
    const modelOptions = document.querySelector('#cabinet2 .custom-dropdown-options');
    
    if (modelInput) {
        modelInput.value = '';
        modelInput.disabled = true;
        modelInput.placeholder = 'Model';
        
        // Remove fake display
        const display = modelInput.parentNode.querySelector('.selected-display');
        if (display) {
            display.remove();
            modelInput.style.display = '';
        }
    }
    
    if (modelOptions) {
        modelOptions.innerHTML = '';
        modelOptions.style.display = 'none';
    }
    
}








  async function loadRAMModels(brand) {
    const modelInput = document.querySelector('#ram2 .custom-dropdown-input');
    const modelOptionsList = document.querySelector('#ram2 .custom-dropdown-options');

    if (!modelInput || !modelOptionsList) return;

    modelInput.classList.add('loading');

    try {
      const motherboardId = window.PCBuilderState.motherboard?.model?.id || '';
      const generationId = window.PCBuilderState.processor?.generation?.id || '';

      const apiUrl = `${apiEndpoints.ram.models}${brand.id}&motherboard_id=${motherboardId}`;

      const res = await fetch(apiUrl, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const json = await res.json();
      let models = json.data?.data || json.data || [];

      models = models.filter(model => 
        model.brand_id === brand.id || 
        (model.brand && model.brand.id === brand.id)
      );

      models = models.map(model => {
        model.displayPrice = window.PCBuilderState.validatePrice(model.price || model.selling_price || 0);
        return model;
      });

      modelInput.classList.remove('loading');

      if (models.length === 0) {
        modelInput.placeholder = 'No models available';
        return;
      }

      populateOptions(modelInput, modelOptionsList, models, async (model) => {
        window.PCBuilderState.ram.model = model;
        window.PCBuilderState.saveToLocalStorage();
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.updateBuildReview();
      }, true);
      

      modelInput.placeholder = 'Model';
    } catch (error) {
      console.error('❌ Error loading RAM models:', error);
      modelInput.classList.remove('loading');
    }
  }

  // CORRECTED API-based Cooler Type Loading Function
async function loadCoolerTypeForced() {
    
    const typeInput = document.querySelector('#cooler1 .custom-dropdown-input');
    const typeOptionsList = document.querySelector('#cooler1 .custom-dropdown-options');
    
    if (!typeInput || !typeOptionsList) {
        console.error('❌ Cooler type elements not found');
        return;
    }
    
    // Enhanced dependency checking with fallbacks
    const processorGeneration = window.PCBuilderState.processor?.generation;
    const cabinetModel = window.PCBuilderState.cabinet?.model;
    
    // Fallback to localStorage
    let fallbackProcessor = null;
    let fallbackCabinet = null;
    
    if (!processorGeneration || !cabinetModel) {
        const savedState = localStorage.getItem('pcBuilderState');
        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);
                fallbackProcessor = processorGeneration || parsedState.processor?.generation;
                fallbackCabinet = cabinetModel || parsedState.cabinet?.model;
            } catch (error) {
                console.error('Error parsing saved state:', error);
            }
        }
    }
    
    const finalProcessor = processorGeneration || fallbackProcessor;
    const finalCabinet = cabinetModel || fallbackCabinet;
    
    if (!finalProcessor || !finalCabinet) {
        typeInput.disabled = true;
        typeInput.placeholder = 'Select Processor & Cabinet first';
        return;
    }
    
    // FORCE ENABLE
    typeInput.disabled = false;
    typeInput.placeholder = 'Loading types...';
    typeInput.classList.add('loading');
    
    
    try {
        // Get cooler types from loaded enums (API-based)
        let enumOptions = window.PCBuilderEnums?.cooler_types; // CORRECTED KEY NAME
        
        // If enums not available, reload them
        if (!enumOptions || !Array.isArray(enumOptions)) {
            await loadEnums(); // Reload enums from API
            enumOptions = window.PCBuilderEnums?.cooler_types; // CORRECTED KEY NAME
        }
        
        // Final fallback if API enum still not available
        if (!enumOptions || !Array.isArray(enumOptions)) {
            console.warn('⚠️ API cooler_types not available, using minimal fallback');
            enumOptions = [
                { value: 1, label: 'Air Cooler' },
                { value: 2, label: 'Liquid Cooler' }
            ];
        }
        
        
        // Check if processor has stock cooler support
        const processorModel = finalProcessor?.model || window.PCBuilderState.processor?.model;
        let filteredOptions = [...enumOptions]; // Create a copy
        
        // Filter out stock cooler if processor doesn't support it
        if (processorModel && processorModel.isstockcooler == 0) {
            filteredOptions = enumOptions.filter(option => option.value != 3);
        }
        
        // Convert API format to dropdown format
        const typeOptions = filteredOptions.map(option => ({
            id: option.value,
            name: option.label
        }));
        
        typeInput.classList.remove('loading');
        
        if (typeOptions.length === 0) {
            typeInput.placeholder = 'No types available';
            return;
        }
        
        
        populateOptions(typeInput, typeOptionsList, typeOptions, async (type) => {
            
            // Reset subsequent dropdowns
            for (let i = 2; i <= 3; i++) {
                const input = document.querySelector(`#cooler${i} .custom-dropdown-input`);
                const options = document.querySelector(`#cooler${i} .custom-dropdown-options`);
                
                if (input) {
                    input.value = '';
                    input.disabled = i === 2 ? false : true; // Enable brand, disable model initially
                    input.placeholder = i === 2 ? 'Loading brands...' : 'Model';
                    
                    const display = input.parentNode.querySelector('.selected-display');
                    if (display) display.remove();
                    input.style.display = '';
                }
                
                if (options) {
                    options.innerHTML = '';
                }
            }
            
            // Update state
            window.PCBuilderState.cooler.type = type;
            window.PCBuilderState.cooler.brand = null;
            window.PCBuilderState.cooler.model = null;
            window.PCBuilderState.saveToLocalStorage();
            
            // Load brands for the selected type
            await loadCoolerBrands();
            
        }, false);
        
        typeInput.placeholder = 'Type';
        
        // Force remove dependency disabled class
        const firstDropdown = document.querySelector('#cooler1');
        if (firstDropdown) {
            firstDropdown.classList.remove('dependency-disabled');
        }
        
        
    } catch (error) {
        console.error('❌ Error loading cooler types from API:', error);
        typeInput.classList.remove('loading');
        typeInput.placeholder = 'Error loading types';
        
        // Emergency fallback - enable with basic types
        const emergencyTypes = [
            { id: 1, name: 'Air Cooler' },
            { id: 2, name: 'Liquid Cooler' }
        ];
        
        
        populateOptions(typeInput, typeOptionsList, emergencyTypes, async (type) => {
            window.PCBuilderState.cooler.type = type;
            window.PCBuilderState.cooler.brand = null;
            window.PCBuilderState.cooler.model = null;
            window.PCBuilderState.saveToLocalStorage();
            await loadCoolerBrands();
        }, false);
        
        typeInput.placeholder = 'Type';
    }
}



  // Cooler Loading Functions
  async function loadCoolerBrands() {
    const brandInput = document.querySelector('#cooler2 .custom-dropdown-input');
    const brandOptionsList = document.querySelector('#cooler2 .custom-dropdown-options');

    if (!brandInput || !brandOptionsList) return;

    if (!window.PCBuilderState.checkDependencies('cooler')) {
      return;
    }

    brandInput.disabled = false;
    brandInput.placeholder = 'Loading brands...';
    brandInput.classList.add('loading');

    try {
        const coolerTypeValue = window.PCBuilderState.cooler?.type?.id || '';
      const cabinetId = window.PCBuilderState.cabinet?.model?.id || '';
      const generationId = window.PCBuilderState.processor?.generation?.id || '';


        const apiUrl = `${apiEndpoints.cooler.brands}cooler_type=${coolerTypeValue}&cabinet_id=${cabinetId}&generation_id=${generationId}`;
       const res = await fetch(apiUrl, {
      headers: {
        'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

      const json = await res.json();
      const brands = json.data?.data || json.data || [];

      brandInput.classList.remove('loading');

      if (brands.length === 0) {
        brandInput.placeholder = 'No brands available';
        return;
      }
      // const requireConfirmation = window.PCBuilderState.hasComponentSelection && 
      //                             window.PCBuilderState.hasComponentSelection('cooler');
      populateOptions(brandInput, brandOptionsList, brands, async (brand) => {
        const modelInput = document.querySelector('#cooler3 .custom-dropdown-input');
        const modelOptions = document.querySelector('#cooler3 .custom-dropdown-options');

        if (modelInput) {
          modelInput.value = '';
          modelInput.disabled = false;
          modelInput.placeholder = 'Loading models...';
          const display = modelInput.parentNode.querySelector('.selected-display');
          if (display) {
            display.remove();
            modelInput.style.display = '';
          }
        }
        if (modelOptions) modelOptions.innerHTML = '';

        window.PCBuilderState.cooler.brand = brand;
        window.PCBuilderState.cooler.model = null;
        window.PCBuilderState.saveToLocalStorage();
        await loadCoolerModels(brand);
      }, false, 'cooler');

      brandInput.placeholder = 'Brand';
    } catch (error) {
      console.error('❌ Error loading cooler brands:', error);
      brandInput.classList.remove('loading');
    }
  }

  async function loadCoolerModels(brand) {
    const modelInput = document.querySelector('#cooler3 .custom-dropdown-input');
    const modelOptionsList = document.querySelector('#cooler3 .custom-dropdown-options');

    if (!modelInput || !modelOptionsList) return;

    modelInput.classList.add('loading');

    try {
      const brandId = brand.id;
      const coolerTypeValue = window.PCBuilderState.cooler?.type?.id || '';
      const generationId = window.PCBuilderState.processor?.generation?.id || '';
      const cabinetId = window.PCBuilderState.cabinet?.model?.id || '';

      const apiUrl = `${apiEndpoints.cooler.models}${brandId}&cooler_type=${coolerTypeValue}&cabinet_id=${cabinetId}&generation_id=${generationId}`;

      const res = await fetch(apiUrl, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const json = await res.json();
      let models = json.data?.data || json.data || [];

      models = models.map(model => {
        model.displayPrice = window.PCBuilderState.validatePrice(model.price || model.selling_price || 0);
        return model;
      });

      modelInput.classList.remove('loading');

      if (models.length === 0) {
        modelInput.placeholder = 'No models available';
        return;
      }

      populateOptions(modelInput, modelOptionsList, models, async (model) => {
        window.PCBuilderState.cooler.model = model;
        window.PCBuilderState.saveToLocalStorage();
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.updateBuildReview();
      }, true);

      modelInput.placeholder = 'Model';
    } catch (error) {
      console.error('❌ Error loading cooler models:', error);
      modelInput.classList.remove('loading');
    }
  }

  // OS Loading Function
  async function loadOSList() {
    const osInput = document.querySelector('#os1 .custom-dropdown-input');
    const osOptionsList = document.querySelector('#os1 .custom-dropdown-options');

    if (!osInput || !osOptionsList) return;

    osInput.disabled = false;
    osInput.placeholder = 'Loading OS...';
    osInput.classList.add('loading');

    try {
      const res = await fetch(apiEndpoints.os.list, {
        headers: {
          'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const json = await res.json();
      let osList = json.data?.data || json.data || [];

      osList = osList.map(os => {
        os.displayPrice = window.PCBuilderState.validatePrice(os.price || os.selling_price || 0);
        return os;
      });

      osInput.classList.remove('loading');

      if (osList.length === 0) {
        osInput.placeholder = 'No OS available';
        return;
      }

      populateOptions(osInput, osOptionsList, osList, async (os) => {
        window.PCBuilderState.os = { brand: { name: 'os' }, model: os };
        window.PCBuilderState.saveToLocalStorage();
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.updateBuildReview();
      }, true);

      // Preselect saved OS from localStorage state
      const savedOs = window.PCBuilderState.os;
      if (savedOs?.model?.id) {
        const matchedOs = osList.find(o => o.id === savedOs.model.id);
        if (matchedOs) {
          updateInputDisplay(osInput, matchedOs, true);
          osInput.disabled = false;
        }
      }

       const totalPrice = window.PCBuilderState.calculateTotalPrice();
      if (typeof refreshRazorpayWidget === 'function') {
        refreshRazorpayWidget(totalPrice);
      }

      osInput.placeholder = 'Select OS';
    } catch (error) {
      console.error('❌ Error loading OS list:', error);
      osInput.classList.remove('loading');
    }
  }

  // ======================================================================
// SECTION 16.5: Custom Mod Loading Functions - ADD THIS SECTION
// ======================================================================
// Fix loadCustomModCategories function
async function loadCustomModCategories(index = 0) {
    const categoryInput = document.querySelector(`#custom-mod${index + 1}-1 .custom-dropdown-input`);
    const categoryOptionsList = document.querySelector(`#custom-mod${index + 1}-1 .custom-dropdown-options`);
    
    if (!categoryInput || !categoryOptionsList) {
        console.error("Custom mod category elements not found");
        return;
    }
    
    // Force enable the input
    categoryInput.disabled = false;
    categoryInput.placeholder = "Loading categories...";
    categoryInput.classList.add('loading');
    
    try {
        const res = await fetch(apiEndpoints['custom-mod'].categories, {
            headers: {
                'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        
        const json = await res.json();
        const categories = json.data?.data || json.data;
        
        categoryInput.classList.remove('loading');
        
        if (!categories || categories.length === 0) {
            categoryInput.placeholder = "No categories available";
            return;
        }
        
        populateOptions(categoryInput, categoryOptionsList, categories, async (category) => {
            // Reset brand and model dropdowns
            const brandInput = document.querySelector(`#custom-mod${index + 1}-2 .custom-dropdown-input`);
            const brandOptions = document.querySelector(`#custom-mod${index + 1}-2 .custom-dropdown-options`);
            
            if (brandInput) {
                brandInput.value = "";
                brandInput.disabled = false;
                brandInput.placeholder = "Loading brands...";
                
                const display = brandInput.parentNode.querySelector('.selected-display');
                if (display) display.remove();
                brandInput.style.display = '';
            }
            
            if (brandOptions) {
                brandOptions.innerHTML = "";
            }
            
            // Ensure customMods array exists
            if (!window.PCBuilderState.customMods) {
                window.PCBuilderState.customMods = [];
            }
            
            // Extend array if needed
            while (window.PCBuilderState.customMods.length <= index) {
                window.PCBuilderState.customMods.push({ category: null, brand: null, model: null });
            }
            
            window.PCBuilderState.customMods[index].category = category;
            window.PCBuilderState.customMods[index].brand = null;
            window.PCBuilderState.customMods[index].model = null;
            window.PCBuilderState.saveToLocalStorage();
            
            await loadCustomModBrands(category, index);
        }, false);
        
        categoryInput.placeholder = "Category";
        
    } catch (error) {
        console.error("Error loading custom mod categories:", error);
        categoryInput.classList.remove('loading');
        categoryInput.placeholder = "Error loading categories";
    }
}


async function loadCustomModBrands(category, index = 0) {
  const brandInput = document.querySelector(`#custom-mod${index + 1}-2 .custom-dropdown-input`);
  const brandOptionsList = document.querySelector(`#custom-mod${index + 1}-2 .custom-dropdown-options`);

  if (!brandInput || !brandOptionsList) return;

  brandInput.classList.add('loading');

  try {
    const res = await fetch(apiEndpoints['custom-mod'].brands + category.id, {
      headers: {
        'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const json = await res.json();
    const brands = json.data?.data || json.data || [];

    brandInput.classList.remove('loading');

    if (brands.length === 0) {
      brandInput.placeholder = 'No brands available';
      return;
    }

    populateOptions(brandInput, brandOptionsList, brands, async (brand) => {
      const modelInput = document.querySelector(`#custom-mod${index + 1}-3 .custom-dropdown-input`);
      const modelOptions = document.querySelector(`#custom-mod${index + 1}-3 .custom-dropdown-options`);

      if (modelInput) {
        modelInput.value = '';
        modelInput.disabled = false;
        modelInput.placeholder = 'Loading models...';
        const display = modelInput.parentNode.querySelector('.selected-display');
        if (display) {
          display.remove();
          modelInput.style.display = '';
        }
      }
      if (modelOptions) modelOptions.innerHTML = '';

      window.PCBuilderState.customMods[index].brand = brand;
      window.PCBuilderState.customMods[index].model = null;
      window.PCBuilderState.saveToLocalStorage();
      await loadCustomModModels(category, brand, index);
    }, false);

    brandInput.placeholder = 'Brand';
  } catch (error) {
    console.error('❌ Error loading custom mod brands:', error);
    brandInput.classList.remove('loading');
  }
}

async function loadCustomModModels(category, brand, index = 0) {
  const brandId = brand.id;
  const modelInput = document.querySelector(`#custom-mod${index + 1}-3 .custom-dropdown-input`);
  const modelOptionsList = document.querySelector(`#custom-mod${index + 1}-3 .custom-dropdown-options`);

  if (!modelInput || !modelOptionsList) return;

  modelInput.classList.add('loading');

  try {

    
    const apiUrl = `${apiEndpoints['custom-mod'].models}&brand_id=${brandId}&category_id=${category.id}`;
    
    const res = await fetch(apiUrl, {
      headers: {
        'Authorization' : `Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const json = await res.json();
    let models = json.data?.data || json.data || [];

    models = models.map(model => {
      model.displayPrice = window.PCBuilderState.validatePrice(model.price || model.selling_price || 0);
      return model;
    });

    modelInput.classList.remove('loading');

    if (models.length === 0) {
      modelInput.placeholder = 'No models available';
      return;
    }

    populateOptions(modelInput, modelOptionsList, models, async (model) => {
      window.PCBuilderState.customMods[index].model = model;
      window.PCBuilderState.saveToLocalStorage();
      window.PCBuilderState.updateFinalPrice();
      window.PCBuilderState.checkFinalAddToCartStatus();
      window.PCBuilderState.updateBuildReview();
    }, true);

    modelInput.placeholder = 'Model';
  } catch (error) {
    console.error('❌ Error loading custom mod models:', error);
    modelInput.classList.remove('loading');
  }
}

// ======================================================================
// SECTION 16.6: Custom Mod UI Management Functions - ADD THIS SECTION
// ======================================================================
function enableFirstCustomMod() {
  
  setTimeout(() => {
    const firstCategoryInput = document.querySelector('#custom-mod1-1 .custom-dropdown-input');
    
    if (!firstCategoryInput) {
      console.error('❌ First custom mod elements not found in DOM');
      return;
    }

    firstCategoryInput.removeAttribute('readonly');
    firstCategoryInput.disabled = false;
    firstCategoryInput.style.cursor = 'pointer';
    firstCategoryInput.style.backgroundColor = '#ffffff';
    firstCategoryInput.placeholder = 'Category';
    
    for (let i = 1; i <= 3; i++) {
      const dropdown = document.querySelector(`#custom-mod1-${i}`);
      const input = document.querySelector(`#custom-mod1-${i} .custom-dropdown-input`);
      const optionsList = document.querySelector(`#custom-mod1-${i} .custom-dropdown-options`);
      
      if (dropdown && input && optionsList) {
        setupDropdownInteractions(dropdown, input, optionsList);
      }
    }
    
  }, 500);
}

function setupAddMoreButton() {
  
  const addButton = document.getElementById('add-more-custom-mods');
  
  if (!addButton) {
    console.error('❌ Add More Custom Mods button not found');
    return;
  }

  const newButton = addButton.cloneNode(true);
  addButton.parentNode.replaceChild(newButton, addButton);
  
  newButton.addEventListener('click', (e) => {
    e.preventDefault();
    addCustomModSection();
  });
  
  updateAddButtonVisibility();
}

function addCustomModSection() {
  
  const currentCount = window.PCBuilderState.customMods.length;
  if (currentCount >= MAX_CUSTOM_MODS) {
    alert(`You can add up to ${MAX_CUSTOM_MODS} custom mods.`);
    return;
  }

  window.PCBuilderState.customMods.push({ category: null, brand: null, model: null });
  window.PCBuilderState.saveToLocalStorage();

  const customModSection = document.getElementById('custom-mod-section');
  const modList = customModSection?.querySelector('.custom-mod-list');
  
  if (!modList) {
    console.error('❌ Custom mod list container not found');
    return;
  }
  
  const newIndex = currentCount + 1;
  const newModDiv = document.createElement('div');
  newModDiv.className = 'flex flex-col gap-4 mb-2 mt-4 custom-mod-group';
  newModDiv.id = `custom-mod-group-${newIndex}`;
  newModDiv.innerHTML = `
   <div class="flex items-center justify-between ">
            <h3 class="text-lg sm:text-xl font-gotham-Bold ">Custom Mod ${newIndex}</h3>
        </div>
    <div class="flex gap-4">  
      <div class="custom-dropdown w-full" id="custom-mod${newIndex}-1">
        <input type="text" class="custom-dropdown-input" placeholder="Category" />
        <ul class="custom-dropdown-options"></ul>
      </div>
      <div class="custom-dropdown w-full" id="custom-mod${newIndex}-2">
        <input type="text" class="custom-dropdown-input" placeholder="Brand" readonly />
        <ul class="custom-dropdown-options"></ul>
      </div>
    </div>
    <div class="custom-dropdown w-full" id="custom-mod${newIndex}-3">
      <input type="text" class="custom-dropdown-input" placeholder="Model" readonly />
      <ul class="custom-dropdown-options"></ul>
    </div>
   <div style="text-align: right;">
  <button 
    class="remove-custom-mod" 
    type="button" 
   style="background: white; color: #800be5; padding: 8px 12px; border: 1px solid #800be5; border-radius: 9px; cursor: pointer; font-size: 12px; font-style: italic;"
>
    Remove
  </button>
</div>

  `;

  modList.appendChild(newModDiv);

  setTimeout(() => {
    for (let i = 1; i <= 3; i++) {
      const dropdown = document.querySelector(`#custom-mod${newIndex}-${i}`);
      const input = dropdown?.querySelector('.custom-dropdown-input');
      const optionsList = dropdown?.querySelector('.custom-dropdown-options');
      
      if (dropdown && input && optionsList) {
        setupDropdownInteractions(dropdown, input, optionsList);
      }
    }
    loadCustomModCategories(currentCount);
  }, 100);

  newModDiv.querySelector('.remove-custom-mod').addEventListener('click', () => {
    removeCustomModSection(currentCount);
  });
 setupCustomModScrolling(newIndex);   


  updateAddButtonVisibility();
}

function setupCustomModScrolling(groupNumber) {
  const customModBrandDropdown = document.getElementById(`custom-mod${groupNumber}-2`);
  const customModModelDropdown = document.getElementById(`custom-mod${groupNumber}-3`);
  
  if (customModBrandDropdown && customModModelDropdown) {
    const brandInput = customModBrandDropdown.querySelector('.custom-dropdown-input');
    
    if (brandInput) {
      // METHOD 1: MutationObserver to detect when brand is selected
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            // Check if brand input has value (brand selected)
            if (brandInput.value && brandInput.value.trim() !== '') {
              // Scroll to model dropdown
              setTimeout(() => {
                customModModelDropdown.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'center' 
                });
              }, 400);
            }
          }
        });
      });
      
      // Observe changes to brand input and its parent
      observer.observe(brandInput, { 
        attributes: true, 
        attributeFilter: ['value'],
        subtree: true 
      });
      
      observer.observe(brandInput.parentNode, {
        childList: true,
        subtree: true
      });
      
      // METHOD 2: Also add change event listener as backup
      brandInput.addEventListener('change', () => {
        if (brandInput.value && brandInput.value.trim() !== '') {
          setTimeout(() => {
            customModModelDropdown.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'center' 
            });
          }, 400);
        }
      });
      
    }
  }
}


function removeCustomModSection(index) {
  
  window.PCBuilderState.customMods.splice(index, 1);
  window.PCBuilderState.saveToLocalStorage();
  window.PCBuilderState.updateFinalPrice();
  window.PCBuilderState.updateBuildReview();

  const modGroups = document.querySelectorAll('.custom-mod-group');
  if (modGroups[index]) {
    modGroups[index].remove();
  }
  
  const remainingGroups = document.querySelectorAll('.custom-mod-group');
  remainingGroups.forEach((group, newIndex) => {
    const oldId = group.id;
    group.id = `custom-mod-group-${newIndex + 1}`;
    
    const dropdowns = group.querySelectorAll('.custom-dropdown');
    dropdowns.forEach((dropdown, dropdownIndex) => {
      dropdown.id = `custom-mod${newIndex + 1}-${dropdownIndex + 1}`;
    });
    
  });

  updateAddButtonVisibility();
}

function updateAddButtonVisibility() {
  const addButton = document.getElementById('add-more-custom-mods');
  if (!addButton) return;
  
  const currentCount = window.PCBuilderState.customMods.length;
  
  if (currentCount >= MAX_CUSTOM_MODS) {
    addButton.classList.add('hidden');
    addButton.disabled = true;
  } else {
    addButton.classList.remove('hidden');
    addButton.disabled = false;
  }
  
  const remaining = MAX_CUSTOM_MODS - currentCount;
  // addButton.textContent = `ADD MORE CUSTOM MODS (${remaining} remaining)`;
}


// ======================================================================
// SECTION 16.7: Brand Change Dependency Reloader
// ======================================================================
window.PCBuilderState.reloadOnBrandChange = async function(component) {
  
  const reloadMap = {
    'cabinet': async () => {
      if (this.checkDependencies('motherboard')) {
        await loadComponentBrands('motherboard');
      }
      if (this.checkDependencies('smps')) {
        await loadSMPSBrandsForced();
      }
      if (this.checkDependencies('cooler')) {
        await loadComponentBrands('cooler');
      }
    },
    'gpu': async () => {
      if (this.checkDependencies('smps')) {
        await loadSMPSBrandsForced();
      }
    },
    'processor': async () => {
      if (this.checkDependencies('motherboard')) {
        await loadComponentBrands('motherboard');
      }
      if (this.checkDependencies('cooler')) {
        await loadComponentBrands('cooler');
      }
    },
    'motherboard': async () => {
      if (this.checkDependencies('ram')) {
        await loadRAMBrands();
      }
    }
  };
  
  const reloadFn = reloadMap[component];
  if (reloadFn) {
    await reloadFn.call(this);
  }
};


  // ======================================================================
  // SECTION 17: Helper Functions for Affected Components
  // ======================================================================
  window.PCBuilderState.getAffectedComponentsWithSelections = function(changedComponent) {
    const affectedComponents = [];
      if (changedComponent === 'smps' && this.smpsNeedsGPUCheck) {
        return ['gpu-dependency']; // Return special flag for GPU dependency
    }
    
    Object.keys(dependencies).forEach(component => {
      const componentDeps = dependencies[component];
      for (let dep of componentDeps) {
        const [parent, child] = dep.split('.');
        if (parent === changedComponent) {
          if (this.hasComponentSelection(component)) {
            affectedComponents.push(component);
          }
          break;
        }
      }
    });
    
    return affectedComponents;
  };

  window.PCBuilderState.hasComponentSelection = function(component) {
    const componentData = this[component];
    
    if (!componentData || typeof componentData !== 'object') {
      return false;
    }

    if (component === 'os') {
      return componentData.model !== null;
    } else if (component === 'processor') {
      return componentData.model !== null;
    } else if (component.includes('storage') || component === 'cooler') {
      const firstKey = 'type';
      return componentData[firstKey] !== null && componentData.model !== null;
    } else {
      return componentData.brand !== null && componentData.model !== null;
    }
  };

  // ======================================================================
  // SECTION 18: Add to Cart Status Check
  // ======================================================================
  window.PCBuilderState.checkFinalAddToCartStatus = function () {
    const addToCartBtn = document.getElementById('final-add-to-cart');
    const floatingAddToCartBtn = document.getElementById('floating-add-to-cart');

    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('bg-disable');
      addToCartBtn.classList.add('bg-[#800be5]', 'hover:bg-gray-800');
    }

    if (floatingAddToCartBtn) {
      floatingAddToCartBtn.disabled = false;
      floatingAddToCartBtn.style.background = '#800be5';
    }
  };

  // ======================================================================
  // SECTION 19: Setup All Dropdown Interactions
  // ======================================================================
  ['cabinet', 'processor', 'motherboard', 'gpu', 'primary-storage', 'secondary-storage', 'optional-storage', 'ram', 'cooler', 'smps', 'os', 'custom-mod'].forEach(component => {
    const prefix = getComponentPrefix(component);
    const dropdownCount = getDropdownCount(component);

    for (let i = 1; i <= dropdownCount; i++) {
      const dropdown = document.querySelector(`#${prefix}${i}`);
      const input = dropdown?.querySelector('.custom-dropdown-input');
      const optionsList = dropdown?.querySelector('.custom-dropdown-options');
      if (dropdown && input && optionsList) {
        setupDropdownInteractions(dropdown, input, optionsList);
      }
    }
  });

  // Button states reset करने के लिए helper function
function resetButtonStates(mainButton, originalText, floatingButton) {
  // Reset main button
  mainButton.disabled = false;
  mainButton.textContent = originalText;
  
  // Reset floating button
  if (floatingButton) {
    floatingButton.disabled = false;
    floatingButton.textContent = 'Add to Cart';
  }
}

  // ======================================================================
  // SECTION 20: Event Listeners for Add to Cart and PDF
  // ======================================================================
 function setupEventListeners() {
  const addToCartBtn = document.getElementById('final-add-to-cart');
  addToCartBtn?.addEventListener('click', async function (e) {
    e.preventDefault();

    const originalText = this.textContent;
    this.disabled = true;
    this.textContent = 'Adding to Cart...';

    const floatingBtn = document.getElementById('floating-add-to-cart');
    if (floatingBtn) {
      floatingBtn.disabled = true;
      floatingBtn.textContent = 'Adding...';
    }

    try {
      clearErrorMessages();
      const validationError = await validateComponents();
      if (validationError) {
        resetButtonStates(this, originalText, floatingBtn);
        return; // Validation failed, error shown and scrolled
      }
      
      // Generate config ID exactly like your API configurator
      const _config_id = `config_${Date.now()}`;
      
      // Dynamic selected upgrades mapping from window.PCBuilderState
      const state = window.PCBuilderState;
      
      const selectedUpgrades = {
  base: {
    variantId: window.PCBuilderState?.cabinet?.model?.shopify_variant_id || null,
    title: "Base PC Configuration",
    price: 0,
    isDefault: true
  }
};

      // Helper function to safely get variant ID and title
      const getComponentData = (component, fallbackTitle) => {
        if (component?.model?.shopify_variant_id) {
          return {
            variantId: component.model.shopify_variant_id,
            title: component.model.title || component.model.name || fallbackTitle,
            price: component.model.price || 0,
            isDefault: false
          };
        }
        return null;
      };

      // Component mapping with validation conditions - matching your validation logic
      const componentMappings = [
        // Always required components
       
        { 
          key: 'component2', 
          stateKey: 'processor', 
          title: 'Processor',
          condition: () => true // Always required
        }, 
        { 
          key: 'component3', 
          stateKey: 'motherboard', 
          title: 'Motherboard',
          condition: () => true // Always required
        },
        { 
          key: 'component5', 
          stateKey: 'smps', 
          title: 'SMPS',
          condition: () => true // Always required
        },
        { 
          key: 'component6', 
          stateKey: 'primary-storage', 
          title: 'Primary Storage',
          condition: () => true // Always required
        },
        { 
          key: 'component9', 
          stateKey: 'ram', 
          title: 'RAM',
          condition: () => true // Always required
        },
        
        // Conditional components - only include if conditions are met
        { 
          key: 'component4', 
          stateKey: 'gpu', 
          title: 'Graphics Card',
          condition: () => !state.gpuSkipped // Only if GPU check needed and not skipped
        },
        { 
          key: 'component7', 
          stateKey: 'secondary-storage', 
          title: 'Secondary Storage',
          condition: () => state.storageChoices?.['secondary-storage'] // Only if enabled in storage choices
        },
        { 
          key: 'component8', 
          stateKey: 'optional-storage', 
          title: 'Optional Storage',
          condition: () => state.storageChoices?.['optional-storage'] // Only if enabled in storage choices
        },
        { 
          key: 'component10', 
          stateKey: 'cooler', 
          title: 'Cooler',
          condition: () => state.storageChoices?.cooler // Only if enabled in storage choices
        }
      ];

      // Build selectedUpgrades dynamically with condition checks
      componentMappings.forEach(mapping => {
        // Only process if the condition is met (component is required or enabled)
        if (mapping.condition()) {
          const componentData = getComponentData(state[mapping.stateKey], mapping.title);
          if (componentData) {
            selectedUpgrades[mapping.key] = componentData;
          }
        }
      });

      // Handle OS separately (always required)
      if (state.os?.model?.shopify_variant_id) {
        selectedUpgrades.os = {
          variantId: state.os.model.shopify_variant_id,
          title: state.os.model.title || state.os.model.name || 'Operating System',
          price: state.os.model.price || 0,
          isDefault: false
        };
      }

      // Handle custom modifications (only if enabled and exist)
      if (state.storageChoices?.['custom-mod'] && state.customMods && state.customMods.length > 0) {
        state.customMods.forEach((mod, index) => {
         if (mod?.model?.shopify_variant_id) {  // model.shopify_variant_id
    selectedUpgrades[`customMod${index + 1}`] = {
        variantId: mod.model.shopify_variant_id,  // model से variant ID
        title: mod.model.name || `Custom Modification ${index + 1}`,
        price: mod.model.price || 0,
        isDefault: false
    };
}
        });
      }


      // Build items array exactly like your API code
      const allItemsToAdd = [];

      // Add selected upgrades (same loop structure as your API)
       allItemsToAdd.push({
    id: "42965800517841",
    quantity: 1,
    properties:{
      '_config_id': _config_id,
    }
});
      for (const [group, upgrade] of Object.entries(selectedUpgrades)) {
        if (!upgrade.variantId) {
          console.warn(`No variant ID for ${group} - ${upgrade.title}, skipping`);
          continue;
        }

    

        allItemsToAdd.push({
          id: upgrade.variantId,
          quantity: 1,
          properties: {
            '_pc_config': 'yes',
            '_item_type': group === 'base' ? 'base' : 'upgrade',
            '_config_id': _config_id,
            '_upgrade_type': group,
            '_bundle_name': 'Custom PC Build', 
            '_upgrade_title': upgrade.title,
            '_upgrade_price': upgrade.price.toString(),
            '_upgrade_subtype': upgrade.type || 'component'
          }
        });
      }

          

     

      // Single batch API call exactly like your optimized approach
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {

          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: allItemsToAdd
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Batch cart addition failed: ${response.status} - ${errorText}`);
      }

      const result = await response.json();

      // Success feedback
      this.textContent = 'Added to Cart!';
      if (floatingBtn) {
        floatingBtn.textContent = ' Added!';
      }

      // Redirect to cart after success
      setTimeout(() => {
        window.location.href = '/pages/upsells';
      }, 2000);

    } catch (error) {
      console.error('❌ Batch cart addition error:', error);
      alert(`❌ Error adding to cart: ${error.message}`);
      
      resetButtonStates(this, originalText, floatingBtn);
      // Reset buttons
      this.disabled = false;
      this.textContent = originalText;
      if (floatingBtn) {
        floatingBtn.disabled = false;
        floatingBtn.textContent = 'Add to Cart';
      }
    }
  });
}




async function validateComponents() {
  const state = window.PCBuilderState;
  
  // Component validation mapping based on file structure [file:62]
  const validations = [
    {
      key: 'cabinet',
      sectionId: 'cabinet-section',
      check: () => !state.cabinet?.model?.shopify_variant_id,
      message: 'Please select a cabinet',
      fieldSelector: '#cabinet2' // Model dropdown
    },
    {
      key: 'processor',
      sectionId: 'processor-section', 
      check: () => !state.processor?.model?.shopify_variant_id,
      message: 'Please select a processor',
      fieldSelector: '#processor3' // Model dropdown
    },
    {
      key: 'motherboard',
      sectionId: 'motherboard-section',
      check: () => !state.motherboard?.model?.shopify_variant_id,
      message: 'Please select a motherboard',
      fieldSelector: '#motherboard2' // Model dropdown
    },
    {
      key: 'gpu',
      sectionId: 'gpu-section',
      check: () => state.smpsNeedsGPUCheck && !state.gpuSkipped && !state.gpu?.model?.shopify_variant_id,
      message: 'Please select a graphics card or skip GPU',
      fieldSelector: '#gpu2' // Model dropdown
    },
    {
      key: 'smps',
      sectionId: 'smps-section',
      check: () => !state.smps?.model?.shopify_variant_id,
      message: 'Please select an SMPS',
      fieldSelector: '#smps2' // Model dropdown
    },
    {
      key: 'primary-storage',
      sectionId: 'primary-storage-section',
      check: () => !state['primary-storage']?.model?.shopify_variant_id,
      message: 'Please select primary storage',
      fieldSelector: '#primary-storage3' // Model dropdown
    },
    {
      key: 'secondary-storage',
      sectionId: 'secondary-storage-section',
      check: () => state.storageChoices?.['secondary-storage'] && !state['secondary-storage']?.model?.shopify_variant_id,
      message: 'Please select secondary storage or change to "No"',
      fieldSelector: '#secondary-storage3' // Model dropdown
    },
    {
      key: 'optional-storage',
      sectionId: 'optional-storage-section',
      check: () => state.storageChoices?.['optional-storage'] && !state['optional-storage']?.model?.shopify_variant_id,
      message: 'Please select optional storage or change to "No"',
      fieldSelector: '#optional-storage3' // Model dropdown
    },
    {
      key: 'ram',
      sectionId: 'ram-section',
      check: () => !state.ram?.model?.shopify_variant_id,
      message: 'Please select RAM',
      fieldSelector: '#ram2' // Model dropdown
    },
    {
      key: 'cooler',
      sectionId: 'cooler-section',
      check: () => state.storageChoices?.cooler && !state.cooler?.model?.shopify_variant_id,
      message: 'Please select a cooler or change to "No"',
      fieldSelector: '#cooler3' // Model dropdown
    },
    {
      key: 'custom-mod',
      sectionId: 'custom-mod-section',
      check: () => state.storageChoices?.['custom-mod'] && (!state.customMods || state.customMods.length === 0),
      message: 'Please add at least one custom modification or change to "No"',
      fieldSelector: '#custom-mod1-3' // First custom mod model dropdown
    },
    {
      key: 'os',
      sectionId: 'os-section',
      check: () => !state.os?.model?.shopify_variant_id,
      message: 'Please select an operating system',
      fieldSelector: '#os1' // OS dropdown
    }
  ];

  // Check each validation
  for (const validation of validations) {
    // validateComponents ke andar, validations loop ke turant baad:
{
  const mb = state.motherboard?.model;
  const procGen = state.processor?.generation;
  const cabinet = state.cabinet?.model;

  // Processor–Motherboard compatibility (processorgenerationids)
 

  // Cabinet–Motherboard size compatibility (reuse existing logic structure)
 
}

    if (validation.check()) {
      await showErrorAndScroll(validation.sectionId, validation.fieldSelector, validation.message);
      return true; // Validation failed
    }
  }


    const selectedMb = window.PCBuilderState.motherboard?.model;
  if (selectedMb) {
    const isComptable =checkMotherboardCabinetCompatibility(selectedMb);
    if (isComptable){
      return true;
    }
  }
  return false; // All validations passed
}

// Show error message under specific field and scroll to it [file:62]
async function showErrorAndScroll(sectionId, fieldSelector, message) {
  const section = document.getElementById(sectionId);
  const field = document.querySelector(fieldSelector);
  
  if (section && field) {
    // Clear any existing errors in this section
    const existingError = section.querySelector('.validation-error');
    if (existingError) {
      existingError.remove();
    }

    // Create error message element
    const errorDiv = document.createElement('div');
    errorDiv.className = 'validation-error';
    errorDiv.style.cssText = `
      background-color: #fee2e2;
      border: 1px solid #fecaca;
      color: #dc2626;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 13px;
      margin-top: 8px;
      animation: fadeIn 0.3s ease;
    `;
    errorDiv.textContent = message;

    // Add error message after the field
    const fieldParent = field.closest('.custom-dropdown') || field.parentElement;
    if (fieldParent) {
      fieldParent.appendChild(errorDiv);
    }

    // Highlight the field
    field.style.borderColor = '#dc2626';
    field.style.boxShadow = '0 0 0 3px rgba(220, 38, 38, 0.1)';

    // Show the section if it's hidden
    section.style.display = 'block';

    // Smooth scroll to the section
    await new Promise(resolve => {
      section.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center',
        inline: 'nearest'
      });
      setTimeout(resolve, 800); // Wait for scroll to complete
    });

    // Focus on the field
    field.focus();
  }
}

// Clear all error messages
function clearErrorMessages() {
  const errorMessages = document.querySelectorAll('.validation-error');
  errorMessages.forEach(error => error.remove());

  // Reset field styles
  const allInputs = document.querySelectorAll('.custom-dropdown-input');
  allInputs.forEach(input => {
    input.style.borderColor = '#212426';
    input.style.boxShadow = '';
  });
}

// Show general error
function showError(type, message) {
  alert(message);
}


// Error message clear karne ka function
function clearFieldError(fieldSelector) {
  const field = document.querySelector(fieldSelector);
  if (field) {
    // Remove error styling
    field.style.borderColor = '#212426';
    field.style.boxShadow = '';
    
    // Remove error message
    const fieldParent = field.closest('.custom-dropdown') || field.parentElement;
    if (fieldParent) {
      const existingError = fieldParent.querySelector('.validation-error');
      if (existingError) {
        existingError.remove();
      }
    }
  }
}

// Enhanced event listeners for real-time validation clearing
function setupValidationClearListeners() {
  // Component mapping for clearing errors [file:60]
  const componentFieldMap = {
    'cabinet': '#cabinet2',
    'processor': '#processor3',
    'motherboard': '#motherboard2',
    'gpu': '#gpu2',
    'smps': '#smps2',
    'primary-storage': '#primary-storage3',
    'secondary-storage': '#secondary-storage3',
    'optional-storage': '#optional-storage3',
    'ram': '#ram2',
    'cooler': '#cooler3',
    'custom-mod': '#custom-mod1-3',
    'os': '#os1'
  };

  // Add listeners to all model selection inputs
  Object.entries(componentFieldMap).forEach(([componentType, fieldSelector]) => {
    const field = document.querySelector(fieldSelector);
    if (field) {
      // Clear error when user selects something
      field.addEventListener('change', () => {
        clearFieldError(fieldSelector);
      });
      
      // Also clear on input/focus
      field.addEventListener('input', () => {
        clearFieldError(fieldSelector);
      });
    }
  });

  // Special handling for storage choice radios
  const storageRadioGroups = ['secondary-storage-choice', 'optional-storage-choice', 'cooler-choice', 'custom-mod-choice'];
  
  storageRadioGroups.forEach(groupName => {
    const radios = document.querySelectorAll(`input[name="${groupName}"]`);
    const storageType = groupName.replace('-choice', '');
    const fieldSelector = componentFieldMap[storageType];
    
    radios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        if (e.target.value === 'no') {
          // Clear error when user selects "No"
          clearFieldError(fieldSelector);
        }
      });
    });
  });

  // GPU skip button handling
  const skipGPUBtn = document.getElementById('skip-gpu-btn');
  const unskipGPUBtn = document.getElementById('unskip-gpu-btn');
  
  if (skipGPUBtn) {
    skipGPUBtn.addEventListener('click', () => {
      clearFieldError('#gpu2');
    });
  }
  
  if (unskipGPUBtn) {
    unskipGPUBtn.addEventListener('click', () => {
      clearFieldError('#gpu2');
    });
  }
}

// Enhanced PCBuilderState model selection with error clearing
// Modify existing model selection callbacks to clear errors

// Example for motherboard (add to existing loadMotherboardModels function)
function enhanceModelSelectionWithErrorClearing() {
  // Override existing PCBuilderState model selections
  const originalMotherboardSelection = window.PCBuilderState.motherboard;
  
  // Add watcher for motherboard model selection
  Object.defineProperty(window.PCBuilderState.motherboard, 'model', {
    get() {
      return originalMotherboardSelection.model;
    },
    set(value) {
      originalMotherboardSelection.model = value;
      // Clear error when model is selected
      if (value) {
        clearFieldError('#motherboard2');
      }
    }
  });
}


// Add selected components to cart (simplified version of previous function)
async function addSelectedComponentsToCart(allItemsToAdd, configId) {
  const state = window.PCBuilderState;

  // Function to get variant ID from product ID
  async function getVariantId(productId) {
    try {
      const response = await fetch(`/products/${productId}.js`);
      const product = await response.json();
      return product.variants[0]?.id;
    } catch (error) {
      console.error('Error fetching variant for product:', productId);
      return null;
    }
  }

  // Add all selected components
  const componentTypes = ['cabinet', 'processor', 'motherboard', 'ram', 'smps', 'primary-storage', 'os'];
  
  for (const componentType of componentTypes) {
    const componentData = state[componentType];
    if (componentData?.model?.shopify_variant_id) {
      const variantId = await getVariantId(componentData.model.shopify_variant_id);
      if (variantId) {
        allItemsToAdd.push({
          id: variantId.toString(),
          quantity: 1,
          properties: {
            'pcconfig': 'yes',
            'item_type': 'component',
            'config_id': configId,
            'component_type': componentType,
            'bundle_name': '{{ product.title | escape }}'
          }
        });
      }
    }
  }

  // Add conditional components (GPU, storage, cooler, custom mods)
  // ... (similar logic as previous function)
}

// Add CSS animation for error fade in
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;
document.head.appendChild(style);


















  // ======================================================================
  // SECTION 21: Storage Choice Radio Button Functionality
  // ======================================================================
  function setupOptionalChoiceRadios() {
    
    
    window.PCBuilderState.storageChoices = {
      'secondary-storage': false,
      'optional-storage': false,
      'cooler': true,
        'custom-mod': true
    };

    const secondaryRadios = document.querySelectorAll('input[name="secondary-storage-choice"]');
    const secondaryFields = document.getElementById('secondary-storage-fields');
    
    secondaryRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        const isYes = e.target.value === 'yes';
        window.PCBuilderState.storageChoices['secondary-storage'] = isYes;
        
        if (isYes) {
          secondaryFields.classList.remove('storage-fields-hidden');
          secondaryFields.classList.add('storage-fields-visible');
          enableStorageDropdowns('secondary-storage');
          loadTypeOptions('secondary-storage');
        } else {
          secondaryFields.classList.add('storage-fields-hidden');
          secondaryFields.classList.remove('storage-fields-visible');
          resetAndDisableStorage('secondary-storage');
        }
        
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.updateBuildReview();
        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.saveToLocalStorage();
      });
    });

    const optionalRadios = document.querySelectorAll('input[name="optional-storage-choice"]');
    const optionalFields = document.getElementById('optional-storage-fields');
    
    optionalRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        const isYes = e.target.value === 'yes';
        window.PCBuilderState.storageChoices['optional-storage'] = isYes;
        
        if (isYes) {
          optionalFields.classList.remove('storage-fields-hidden');
          optionalFields.classList.add('storage-fields-visible');
          enableStorageDropdowns('optional-storage');
          loadTypeOptions('optional-storage');
        } else {
          optionalFields.classList.add('storage-fields-hidden');
          optionalFields.classList.remove('storage-fields-visible');
          resetAndDisableStorage('optional-storage');
        }
        
        window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.updateBuildReview();

        window.PCBuilderState.checkFinalAddToCartStatus();
        window.PCBuilderState.saveToLocalStorage();
      });
    });
    
    const coolerRadios = document.querySelectorAll('input[name="cooler-choice"]');
  const coolerFields = document.getElementById('cooler-fields');
 coolerRadios.forEach(radio => {
  radio.addEventListener('change', (e) => {
    const isYes = e.target.value === 'yes';
    window.PCBuilderState.storageChoices['cooler'] = isYes;
    
    if (isYes) {
      coolerFields.classList.remove('storage-fields-hidden');
      coolerFields.classList.add('storage-fields-visible');
      loadCoolerTypeForced();  // Reload if needed
    } else {
      coolerFields.classList.add('storage-fields-hidden');
      coolerFields.classList.remove('storage-fields-visible');
      resetAndDisableStorage('cooler');
      
      // NEW LINES TO ADD HERE: Show custom mod and OS when "No" is selected
      const customModSection = document.getElementById('custom-mod-section');
      const osSection = document.getElementById('os-section');
      if (customModSection) customModSection.style.display = "block";
      if (osSection) osSection.style.display = "block";
    }
    
    window.PCBuilderState.updateFinalPrice();
        window.PCBuilderState.updateBuildReview();

    window.PCBuilderState.checkFinalAddToCartStatus();
    window.PCBuilderState.saveToLocalStorage();
  });
});

  const customModRadios = document.querySelectorAll('input[name="custom-mod-choice"]');
    const customModFields = document.getElementById('custom-mod-fields');
    
    customModRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            const isYes = e.target.value === 'yes';
            window.PCBuilderState.storageChoices['custom-mod'] = isYes;
            
            if (isYes) {
                // Show custom mod fields
                customModFields.classList.remove('storage-fields-hidden');
                customModFields.classList.add('storage-fields-visible');
                
                // Enable custom mod functionality
                enableFirstCustomMod();
                setupAddMoreButton();
                loadCustomModCategories(0);
                
            } else {
                // Hide custom mod fields
                customModFields.classList.add('storage-fields-hidden');
                customModFields.classList.remove('storage-fields-visible');
                
                // Reset custom mod data
                resetCustomModData();
                
                // Show OS section when custom mod is "No"
                const osSection = document.getElementById('os-section');
                if (osSection) {
                    osSection.style.display = 'block';
                }
                
            }
            
            // CRITICAL: Update pricing and build review immediately
            window.PCBuilderState.updateFinalPrice();
            window.PCBuilderState.updateBuildReview();
            window.PCBuilderState.checkFinalAddToCartStatus();
            window.PCBuilderState.saveToLocalStorage();
        });
    });

  }

  function enableStorageDropdowns(storageType) {
    const prefix = getComponentPrefix(storageType);
    
    for (let i = 1; i <= 3; i++) {
      const input = document.querySelector(`#${prefix}${i} .custom-dropdown-input`);
      if (input) {
        input.disabled = false;
        if (i === 1) {
          input.readOnly = false;
        }
      }
    }
  }

  function resetAndDisableStorage(storageType) {
    window.PCBuilderState[storageType] = { type: null, brand: null, model: null };
    
    const prefix = getComponentPrefix(storageType);
    
    for (let i = 1; i <= 3; i++) {
      const input = document.querySelector(`#${prefix}${i} .custom-dropdown-input`);
      const options = document.querySelector(`#${prefix}${i} .custom-dropdown-options`);
      
      if (input) {
        input.value = '';
        input.disabled = true;
        input.placeholder = getPlaceholder(storageType, i);
        
        const display = input.parentNode.querySelector('.selected-display');
        if (display) {
          display.remove();
          input.style.display = '';
        }
      }
      
      if (options) {
        options.innerHTML = '';
      }
    }
  }

  // ======================================================================
  // SECTION 22: Debug Functions (Testing के लिए)
  // ======================================================================
  
  // ✅ DEBUG: State checking function
  window.debugSMPSDependencies = function() {
    const state = window.PCBuilderState;
   
    const savedState = localStorage.getItem('pcBuilderState');
    if (savedState) {
      const parsed = JSON.parse(savedState);
     
    }
  };

  // ✅ DEBUG: Complete state debugging
  window.PCBuilderState.debugState = function() {
    Object.keys(this).forEach(key => {
      if (typeof this[key] === 'object' && this[key] !== null) {
      }
    });
    
    const savedState = localStorage.getItem('pcBuilderState');
    if (savedState) {
    }
  };

  // ======================================================================
  // SECTION 23: Initialization and Loading Components
  // ======================================================================
  
  // Expose a single brand-loader for the shared-build restore script.
  // Defined here (before any await) so it is available the moment DOMContentLoaded
  // fires, regardless of how quickly the shared-build API fetch resolves.
  window.bitkartLoadBrandsForRestore = async function () {
    var s = window.PCBuilderState;
    var jobs = [];
    if (s.processor?.generation?.id && s.processor?.model?.id)
      jobs.push(loadComponentBrands('motherboard'));
    if (s.motherboard?.model?.id)
      jobs.push(loadRAMBrands());
    if (s.cabinet?.model?.id && (s.gpu?.model?.id || s.gpuSkipped))
      jobs.push(loadSMPSBrandsForced());
    if (s.processor?.generation?.id && s.cabinet?.model?.id)
      jobs.push(loadCoolerTypeForced());
    await Promise.all(jobs);
  };

  // Dedicated SMPS brand loader for restore: populates the brand dropdown without
  // clearing state.smps or disabling the input (unlike reloadSMPSWithoutGPU).
  window.bitkartLoadSMPSBrands = async function () {
    var s = window.PCBuilderState;
    var brandInput = document.querySelector('#smps1 .custom-dropdown-input');
    var brandOptionsList = document.querySelector('#smps1 .custom-dropdown-options');
    if (!brandInput || !brandOptionsList) return;

    var cabinetId = s.cabinet?.model?.id;
    if (!cabinetId) return;

    var apiUrl;
    if (s.gpuSkipped) {
      apiUrl = apiEndpoints.smps.brands + 'cabinetid=' + cabinetId;
    } else {
      var graphicId = s.gpu?.model?.id;
      if (!graphicId) return;
      apiUrl = apiEndpoints.smps.brands + 'cabinetid=' + cabinetId + '&graphiccardid=' + graphicId;
    }

    brandInput.disabled = false;
    brandInput.classList.add('loading');

    try {
      var res = await fetch(apiUrl, {
        headers: {
          'Authorization': 'Bearer i0efTd9Bpvq/UbXLLHSM9vhZk3dlIGh8fOhP8+i1Ch0=',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      var json = await res.json();
      var brandOptions = json.data?.data || json.data || [];
      brandInput.classList.remove('loading');
      brandInput.disabled = false;

      if (!brandOptions.length) return;

      populateOptions(brandInput, brandOptionsList, brandOptions, async function (brand) {
        var modelInput = document.querySelector('#smps2 .custom-dropdown-input');
        var modelOptions = document.querySelector('#smps2 .custom-dropdown-options');
        var modelDisplay = document.querySelector('#smps2 .selected-display');
        if (modelInput) { modelInput.value = ''; modelInput.disabled = false; modelInput.placeholder = 'Loading models...'; modelInput.style.display = ''; }
        if (modelOptions) { modelOptions.innerHTML = ''; }
        if (modelDisplay) { modelDisplay.remove(); }
        s.smps.brand = brand;
        s.smps.model = null;
        s.saveToLocalStorage();
        if (s.gpuSkipped) {
          await s.loadSMPSModelsWithoutGPU(brand);
        } else {
          await loadSMPSModels(brand);
        }
      }, false);

      var firstDropdown = document.querySelector('#smps1');
      if (firstDropdown) firstDropdown.classList.remove('dependency-disabled');
    } catch (e) {
      brandInput.classList.remove('loading');
    }
  };

  // Restore custom mods from a shared build: creates DOM groups and fills display values.
  window.bitkartRestoreCustomMods = function(customMods) {
    if (!Array.isArray(customMods) || customMods.length === 0) return;

    var modList = document.querySelector('#custom-mod-section .custom-mod-list');
    if (!modList) return;

    // Sync state
    window.PCBuilderState.customMods = JSON.parse(JSON.stringify(customMods));

    // Create DOM groups for mods 2+ (group 1 already exists in the HTML)
    for (var i = 1; i < customMods.length; i++) {
      var modNum = i + 1;
      if (document.getElementById('custom-mod-group-' + modNum)) continue;

      var newDiv = document.createElement('div');
      newDiv.className = 'flex flex-col gap-4 mb-2 mt-4 custom-mod-group';
      newDiv.id = 'custom-mod-group-' + modNum;
      newDiv.innerHTML =
        '<div class="flex items-center justify-between">' +
          '<h3 class="text-lg sm:text-xl font-gotham-Bold">Custom Mod ' + modNum + '</h3>' +
        '</div>' +
        '<div class="flex gap-4">' +
          '<div class="custom-dropdown w-full" id="custom-mod' + modNum + '-1">' +
            '<input type="text" class="custom-dropdown-input" placeholder="Category" />' +
            '<ul class="custom-dropdown-options"></ul>' +
          '</div>' +
          '<div class="custom-dropdown w-full" id="custom-mod' + modNum + '-2">' +
            '<input type="text" class="custom-dropdown-input" placeholder="Brand" readonly />' +
            '<ul class="custom-dropdown-options"></ul>' +
          '</div>' +
        '</div>' +
        '<div class="custom-dropdown w-full" id="custom-mod' + modNum + '-3">' +
          '<input type="text" class="custom-dropdown-input" placeholder="Model" readonly />' +
          '<ul class="custom-dropdown-options"></ul>' +
        '</div>' +
        '<div style="text-align:right;">' +
          '<button class="remove-custom-mod" type="button" style="background:white;color:#800be5;padding:8px 12px;border:1px solid #800be5;border-radius:9px;cursor:pointer;font-size:12px;font-style:italic;">Remove</button>' +
        '</div>';
      modList.appendChild(newDiv);

      // Capture the group element itself so remove always finds its live position,
      // even after earlier mods have been removed (stale-index bug fix).
      (function(groupEl) {
        var btn = groupEl.querySelector('.remove-custom-mod');
        if (btn) btn.addEventListener('click', function() {
          var currentGroups = Array.from(document.querySelectorAll('.custom-mod-group'));
          var liveIndex = currentGroups.indexOf(groupEl);
          if (liveIndex !== -1) removeCustomModSection(liveIndex);
        });
      })(newDiv);
    }

    // After DOM is ready, wire up interactions, show selected values, and pre-load
    // brand/model options so the user can change selections without re-picking category.
    setTimeout(function() {
      customMods.forEach(function(mod, i) {
        var modNum = i + 1;

        // Wire up dropdown open/close/search interactions
        for (var j = 1; j <= 3; j++) {
          var dd = document.querySelector('#custom-mod' + modNum + '-' + j);
          var inp = dd && dd.querySelector('.custom-dropdown-input');
          var ul  = dd && dd.querySelector('.custom-dropdown-options');
          if (dd && inp && ul) setupDropdownInteractions(dd, inp, ul);
        }

        // Show selected display values
        if (mod.category) {
          var ci = document.querySelector('#custom-mod' + modNum + '-1 .custom-dropdown-input');
          if (ci) updateInputDisplay(ci, mod.category, false);
        }
        if (mod.brand) {
          var bi = document.querySelector('#custom-mod' + modNum + '-2 .custom-dropdown-input');
          if (bi) updateInputDisplay(bi, mod.brand, false);
        }
        if (mod.model) {
          var mi = document.querySelector('#custom-mod' + modNum + '-3 .custom-dropdown-input');
          if (mi) updateInputDisplay(mi, mod.model, true);
        }

        // Pre-load categories so clicking the category display shows all options.
        // Then pre-load brands for the saved category so brand options are ready too.
        // Re-apply display values after each async load because the loaders reset placeholders.
        (function(mod, i, modNum) {
          loadCustomModCategories(i).then(function() {
            if (mod.category) {
              var ci2 = document.querySelector('#custom-mod' + modNum + '-1 .custom-dropdown-input');
              if (ci2) updateInputDisplay(ci2, mod.category, false);
            }
            if (!mod.category) return;
            return loadCustomModBrands(mod.category, i);
          }).then(function() {
            if (mod.brand) {
              var bi2 = document.querySelector('#custom-mod' + modNum + '-2 .custom-dropdown-input');
              if (bi2) updateInputDisplay(bi2, mod.brand, false);
            }
            if (mod.model) {
              var mi2 = document.querySelector('#custom-mod' + modNum + '-3 .custom-dropdown-input');
              if (mi2) updateInputDisplay(mi2, mod.model, true);
            }
          }).catch(function() {});
        })(mod, i, modNum);
      });
      updateAddButtonVisibility();
    }, 200);
  };

  // ✅ Load saved state first
  const stateLoaded = window.PCBuilderState.loadFromLocalStorage();
  
  // Load enums first
  await loadEnums();
  
  // Load independent components first
 // Load independent components first
await Promise.all([
  loadComponentBrands('cabinet'),
  loadComponentBrands('processor'),

  loadComponentBrands('gpu'),
  loadTypeOptions('primary-storage'),
  loadTypeOptions('secondary-storage'),
  loadTypeOptions('optional-storage'),
  loadCoolerTypeForced(),
  loadOSList(),
  setupOptionalChoiceRadios(),
]);

// Enhanced Custom Mod Initialization
setTimeout(() => {
  
  let retryCount = 0;
  const maxRetries = 3;
  
  function initCustomMods() {
    try {
      enableFirstCustomMod();
      setupAddMoreButton();
      loadCustomModCategories(0);
    } catch (error) {
      console.error('❌ Custom Mod initialization failed:', error);
      retryCount++;
      
      if (retryCount < maxRetries) {
        setTimeout(initCustomMods, 1000);
      } else {
      }
    }
  }
  
  initCustomMods();
}, 1000);

  // Set dependency states for dependent components
  ['motherboard', 'ram', 'cooler', 'smps'].forEach(component => {
    window.PCBuilderState.setComponentDependencyState(component);
  });

  // Restore UI if state was loaded
  if (stateLoaded) {
    await restoreUIFromState();
  }

  // Setup event listeners
  setupEventListeners();

  // Initial updates
  window.PCBuilderState.updateFinalPrice();
  window.PCBuilderState.checkFinalAddToCartStatus();
  window.PCBuilderState.updateBuildReview();

});



// MASTER FORCE ENABLE FUNCTION - Add at the end around line 3800
window.forceEnableAllDropdowns = async function() {
    
    // Force enable RAM if motherboard exists
    const motherboardExists = window.PCBuilderState.motherboard?.model?.id;
    if (motherboardExists) {
        await loadRAMBrands();
    }
    
    // Force enable SMPS if cabinet and GPU exist
    const cabinetExists = window.PCBuilderState.cabinet?.model?.id;
    const gpuExists = window.PCBuilderState.gpu?.model?.id;
    if (cabinetExists && gpuExists) {
        await loadSMPSBrandsForced();
    }
    
    // Force enable Cooler if processor and cabinet exist
    const processorExists = window.PCBuilderState.processor?.generation;
    if (processorExists && cabinetExists) {
        loadCoolerTypeForced();
    }
    
};

// Auto-run after component selections
window.autoForceEnable = function() {
    setTimeout(() => {
        window.forceEnableAllDropdowns();
    }, 500);
};

// Debug functions for console
window.debugRAM = async function() {
   
    await loadRAMBrands();
};

window.debugSMPS = async function() {
  
    await loadSMPSBrandsForced();
};

window.debugCooler = function() {
   
    loadCoolerTypeForced();
};
